<template>
  <div class="container-fluid">
    <!-- getCartChecoutLoader -->
  <div v-if="getCartChecoutLoader" class="row" >
      <div class="col-md-7 col-sm-12 col-xs-12 px-1 checkout-Skeleton"  > 
        <PuSkeleton  class=" Skeleton1"  width="100%" height="inherit"  />
        <PuSkeleton  class=" Skeleton2"  width="100%" height="inherit"  />
        <PuSkeleton  class=" Skeleton3"  width="100%" height="inherit"  />

      </div>
      <div class="col-md-5 col-sm-12 col-xs-12 px-1 opc-Skeleton"  > 
        <PuSkeleton  class="checout-Skeleton Skeleton1"  width="100%" height="100vh"  />
      </div>
    </div>
    <div class="row" v-else>
      <div class="col-md-8 col-sm-12 col-xs-12 checkout-section">
        <div class="checkout_header">
          <div class="checkout_logo">
            <button
              @click="goBack()"
              class="forMobile"
              style="
                position: absolute;
                left: 10px;
                padding: 10px;
                color: #333;
                font-size: 25px;
                border: none;
                background: none;
                cursor: pointer;
              "
            >
              <i class="fa fa-angle-left" aria-hidden="true"></i>
            </button>
            <a href="/" class="navbar-brand router-link-active">
              <img
                src="/img/lhm_logo.png"
                alt="LHM"
                title="LHM"
                style="max-width: 180px"
              />
            </a>
          </div>

          <ul class="opc-progress-bar">
            
            <li
              class="opc-progress-bar-item"
              @click="changePageType('shipping')"
              :class="{
                active:
                  this.page_type === 'shipping' ||
                  this.page_type === 'login' ||
                  this.page_type === 'payment' ||
                  this.page_type === 'delivery',
              }"
            >
              <span>Address</span>
            </li>
            <li
              class="opc-progress-bar-item"
              @click="changePageType('delivery')"
              :class="{
                active:
                  this.page_type === 'delivery' || this.page_type === 'payment',
              }"
            >
              <span>Delivery Slot</span>
            </li>
            <li
              class="opc-progress-bar-item"
              @click="changePageType('payment')"
              :class="{ active: this.page_type === 'payment' }"
            >
              <span>PAYMENTS</span>
            </li>
          </ul>
        </div>

        <!-- {{this.$root.address.length}} -->
        <div class="login" v-if="!this.$root.customer_id">
          <h3 class="section-title font-medium">ENTER YOUR MOBILE NUMBER.</h3>
          <form class="login-form text-center">
            <div
              class="field mobile fieldLogin text-left mb-4"
              v-bind:class="{
                success: this.mobile === true,
                error: this.mobile_error != '',
              }"
            >
              <!-- <label class="label"><span>ENTER YOUR MOBILE NUMBER</span></label> -->
              <input
                maxlength="10"
                class="input-text form-control"
                autocomplete="off"
                v-model="mobile_number"
                name="mobile"
              />
              <p class="size_error" v-text="mobile_error"></p>
            </div>
            <button
              type="btn"
              class="getYourOtp"
              v-if="!isOtp"
              @click.prevent="mobile_no"
            >
              Get OTP
            </button>
            <div
              v-if="isOtp"
              class="field otp fieldLogin text-left"
              v-bind:class="{
                success: this.otp === true,
                error: this.otp_error != '',
              }"
            >
              <!-- <label class="label mb-0"
								><span>One Time Password(OTP)</span></label
							>-->
              <input
                class="input-text form-control"
                maxlength="4"
                placeholder="One Time Password (OTP)*"
                type="text"
                name="customerpassword"
                v-model="otp_number"
                :disabled="this.mobile == false"
                autocomplete="off"
                ref="otpCheckout"
              />
              <p class="size_error" v-text="otp_error"></p>
              <label class="timer-main font-medium float-right">
                <!-- <span>Please enter the OTP sent on your mobile</span> -->
                <span
                  class="timer-container"
                  v-if="this.mobile === true && this.resend_otp_time != 60"
                >
                  <span>00:</span>
                  <span class="timer" v-text="this.resend_otp_time"></span>
                </span>
                <!-- <br /> -->
                <a
                  href="#"
                  class="action checkout-otp-resend-button"
                  id="resend"
                  @click.prevent="resend_otp()"
                  v-if="this.mobile === true && this.resend_otp_time === 60"
                >
                  <span>Resend OTP</span>
                </a>
              </label>
            </div>
          </form>
        </div>
        <div
          class="shipping-address-section opc-section"
          id="shipping-address-section"
          v-if="$root.address.length > 0 && page_type === 'shipping'"
        >
          <div class="col-12 text-center deliverySlotText p-0">
            <h3 class="section-title font-medium">Shipping Address</h3>
          </div>
          <div class="shipping-address-items">
            <!-- <p>DEFAULT ADDRESS</p> -->
            <div
              class="shipping-address-item"
              v-for="(items, index) in $root.address"
              :key="index"
              v-if="
                items.pin_code.length === 6 && index <= address_show_hide_length
              "
              v-bind:class="{ selected: select_address_index === index }"
            >
              <div class="address">
                <p class="addressType">
                  {{ items.full_name }}
                  <span>{{ items.address_type }}</span>
                </p>
                {{ items.full_name }},
                <a>{{ items.phone }}</a>
                <br />
                {{ items.street_address }}, {{ items.city }},
                {{ items.state_name }}
                {{ items.pin_code }}
                <br />
                <p class="my-2">
                  mobile :
                  <strong>{{ items.phone }}</strong>
                </p>
                <p class="defaultAddress" v-if="items.default == 1">Default</p>
                <a
                  href="#"
                  @click.prevent="
                    edit_address_address(
                      items.id,
                      items.full_name,
                      items.street_address,
                      items.area,
                      items.city,
                      items.state,
                      items.pin_code,
                      items.phone,
                      items.address_type,
                      items.default,
                      items.flat_no,
                      items.landmark
                    )
                  "
                  class="text-logo-color removeBtn float-left"
                >
                  <i class="fa fa-edit"></i>
                </a>
                <button
                  type="button"
                  class="action action-select-shipping-item"
                  :address_id="items.id"
                  @click="select_address(index, items.id)"
                >
                  <span>Ship Here</span>
                </button>
              </div>
            </div>
          </div>

          <div class="w-100" style="dispaly: inline-block">
            <button
              type="button"
              v-if="address_show_hide === false && $root.address.length > 1"
              v-ripple
              class="new-address-btn show-all-address"
              @click="show_all_address()"
            >
              <span>View All Addresses</span>
            </button>
            <button
              type="button"
              v-if="address_show_hide === true && $root.address.length > 1"
              v-ripple
              class="new-address-btn hide-address"
              @click="hide_all_address()"
            >
              <span>Hide Address</span>
            </button>
            <button
              type="button"
              v-ripple
              class="new-address-btn"
              @click="customer_select_new_address()"
            >
              <span>Add New Address</span>
            </button>

            <span class="submit newFixBtn">
              <button
                type="button"
                id="new_address"
                class="continue float-right"
                @click="assignAddress()"
              >
                NEXT
                <span v-if="isLoading">
                  <i class="fa fa-spinner btnLoader"></i>
                </span>
              </button>
            </span>
          </div>
        </div>
        <!-- && in place of || -->
        <form
          class="login-form"
          v-if="
            this.page_type === 'new_address_page'"
        >
          <h3 class="section-title font-medium">Shipping Address</h3>
          <!-- <PuSkeleton width="100%" height="60px" v-if=""> -->
          <div class="row shippingWrap" >
            <div
              class="form-group col-md-12"
              v-if="this.g_checkout_page === true"
              v-bind:class="{
                success: this.mobile === true,
                error: this.mobile_error != '',
              }"
            >
              <input
                maxlength="10"
                class="input-text form-control"
                autocomplete="off"
                placeholder="Enter Mobile Number*"
                v-model="mobile_number"
                @keyup="g_mobile_no"
                name="mobile"
                autofocus
              />
              <p
                class="size_error mb-0"
                v-text="mobile_error"
                v-if="mobile_error"
              ></p>
            </div>

            <div
              class="form-group col-md-12"
              v-bind:class="{
                success: this.name_error == '' && this.user.name != '',
                error: this.name_error != '',
              }"
            >
              <input
                class="input-text form-control"
                v-model="user.name"
                placeholder="Full Name*"
                autocomplete="off"
                @keyup="user_name"
                type="text"
                name="full_name"
                required
              />
              <p
                class="size_error mb-0"
                v-text="this.name_error"
                v-if="this.name_error"
              ></p>
            </div>
            <div
              class="form-group col-md-12"
              v-bind:class="{
                success: this.email_error == '' && this.user.email != '',
                error: this.email_error != '',
              }"
            >
              <input
                class="input-text form-control"
                @keyup="user_email"
                type="email"
                placeholder="Email*"
                autocomplete="off"
                v-model="user.email"
                name="Email"
                required
              />
              <p
                class="size_error mb-0"
                v-text="this.email_error"
                v-if="this.email_error"
              ></p>
            </div>

            <div
              class="form-group col-md-12"
              v-bind:class="{
                success: this.address_error == '' && this.user.address != '',
                error: this.address_error != '',
              }"
            >
              <input
                class="input-text form-control"
                v-model="user.address"
                placeholder="Street Address*"
                autocomplete="off"
                @keyup="user_address"
                type="text"
                name="street_address"
                required
              />
              <p
                class="size_error mb-0"
                v-text="this.address_error"
                v-if="this.address_error"
              ></p>
            </div>
            <div
              class="form-group col-md-12"
              v-bind:class="{
                success:
                  this.pin_code_error == '' &&
                  this.user.pin_code != '' &&
                  this.user.pin_code != null,
                error: this.pin_code_error != '',
              }"
            >
              <input
                class="input-text form-control"
                type="text"
                placeholder="PIN Code*"
                autocomplete="off"
                @keyup="user_pin_code"
                v-model="user.pin_code"
                name="pin_code"
                id="postcode"
                maxlength="6"
                required
              />
              <p
                class="size_error mb-0"
                v-text="this.pin_code_error"
                v-if="this.pin_code_error"
              ></p>
              <!-- <p class="size_success mb-0"
								v-text="this.pin_code_success"
							v-if="this.pin_code_success"></p>-->
            </div>

            <div
              class="form-group col-md-12"
              v-bind:class="{
                success: this.city_error == '' && this.user.city != '',
                error: this.city_error != '',
              }"
            >
              <input
                class="input-text form-control"
                type="text"
                placeholder="City*"
                autocomplete="off"
                @keyup="user_city"
                v-model="user.city"
                name="city"
                id="city"
                required
              />
              <p
                class="size_error mb-0"
                v-text="this.city_error"
                v-if="this.city_error"
              ></p>
            </div>
            <div
              class="form-group col-md-12"
              v-bind:class="{
                success: this.user.state != '',
                error: this.state_error != '',
              }"
            >
              <input
                class="input-text form-control"
                type="text"
                placeholder="State*"
                autocomplete="off"
                v-model="user.state"
                name="state"
                id="state"
                required
                disabled
              />
              <p class="size_error mb-0"></p>
            </div>

            <div class="form-group col-md-12">
              <label class="font-medium">Select Address Type</label>
              <div class="row">
                <div class="col-4">
                  <label
                    for="home"
                    :class="{
                      addressTypeActive: this.user.address_type == 'home',
                    }"
                  >
                    <!-- <i class="fa fa-home"></i> -->
                    <input
                      type="radio"
                      @change="address_type_change($event)"
                      id="home"
                      name="Type"
                      value="home"
                      :checked="this.user.address_type == 'home'"
                    />
                    Home
                  </label>
                </div>
                <!-- addressType -->
                <div class="col-4">
                  <label
                    class="ml-3"
                    for="office"
                    :class="{
                      addressTypeActive: this.user.address_type == 'office',
                    }"
                  >
                    <!-- <i class="fa fa-briefcase"></i> -->
                    <input
                      type="radio"
                      @change="address_type_change($event)"
                      id="office"
                      name="Type"
                      value="office"
                      :checked="this.user.address_type == 'office'"
                    />
                    Office
                  </label>
                </div>
                <div class="col-4">
                  <label
                    class="ml-3"
                    for="Others"
                    :class="{
                      addressTypeActive: this.user.address_type != 'others',
                    }"
                  >
                    <input
                      type="radio"
                      @change="address_type_change($event)"
                      id="others"
                      name="Type"
                      value="others"
                      :checked="this.user.address_type == 'others'"
                    />
                    Others
                  </label>
                </div>
                <div
                  class="col-4 offset-8"
                  v-if="user.address_type == 'others'"
                >
                  <input
                    v-model="otherAddressType"
                    type="text"
                    class="form-control w-100"
                  />
                </div>
              </div>
              <p
                class="size_error mb-0"
                v-text="this.address_type_error"
                v-if="this.address_type_error"
              ></p>
            </div>
            <span class="submit"></span>

            <div class="col-md-12 text-right mFixed">
              <button
                v-if="$root.address.length > 0"
                @click="changePageType('shipping')"
                type="button"
                class="shippingBackBtn float-left forDesktop"
              >
                <i class="fa fa-arrow-left pr-2"></i>
                Back
              </button>
              <button
                type="submit"
                class="btn shippingBtn text-white px-5"
                @click.prevent="checkAddAddress()"
              >
                Next
              </button>
            </div>
          </div>
        </form>

        <div class="row d-block" v-if="this.page_type === 'delivery'">
          <div class="col-12 text-center deliverySlotText">
            <h3 class="section-title font-medium">Select Delivery Slots</h3>
          </div>

          <div
            v-for="(store, index) in cartWiseSlots"
            class="col-12"
            :key="store.store_id"
          >
            <!-- <div
							v-if="this.page_type === 'delivery'"
							class="timeSlot"
							
							:class="{
								slotDisable: false,
								slotActive: this.scheduleSelectOption == false,
							}"
						>
							{{isExpressDelivery == true ? "Within next 3 hours ": " Tomorrow"}}
							{{ findAvailableSlot() }}
						</div>-->
            <div class="customTab" style="display: block">
              <h4
                style="
                  font-size: 16px;
                  padding: 0px 10px;
                  font-weight: 700;
                  margin: 0;
                  margin-top: 30px;
                "
              >
                <span style="background-color: gray">
                  <img :src="store.store_logo" width="60" height="60" />
                </span>
                {{ storeInTimeSlot(store.store_id) }}
              </h4>
              <div>
                <div v-if="store.store_data && store.store_data.length > 0">
                        <div 
                          class="deliveryotp"
                          :class="{
                            otpselected: otpRequired.includes(store.order_quote_id),
                          }"
                          style="border-bottom: 0.5px solid #efefef"
                          @click="deliveryotp(store.order_quote_id)">
                          <span class="deliveryotptext">Require OTP upon delivery</span>
                        </div>
                  <div
                    v-if="store.temp_close_message == null"
                    class="timeSlot"
                    @click="
                      selectTimeSlot({
                        store_id: store.store_id,
                        slot: store.express_slot,
                        date: store.express_slot.date,
                      });
                      scheduleDelivery(store.store_id, true);
                    "
                    :class="{
                      slotDisable: store.express == false,
                      slotActive: selectedSlots.some(
                        (x) => x.slot == store.express_slot
                      ),
                    }"
                  >
                    Express Delivery
                  </div>
                  <div
                    v-if="store.temp_close_message == null"
                    class="timeSlot"
                    @click="scheduleDelivery(store.store_id)"
                    :class="{
                      slotActive: store.isSchedule == true,
                    }"
                  >
                    Schedule Delivery
                  </div>
                        
                  <div style="margin-top: 30px; margin-bottom: 15px">
                    {{ store.temp_close_message }}
                  </div>
                  <ul v-if="store.isSchedule == true">
                    <li
                      class="tabTitle"
                      :class="{ titleAcitve: item.selectedDate == true }"
                      v-for="item in store.store_data"
                      @click="getTimeSlot(item.date, store.store_id)"
                      :key="item.date"
                    >
                      {{ new Date(item.date).toString().split(" ")[0] }}
                      <span>
                        {{ new Date(item.date).toString().split(" ")[2] }}
                        {{ new Date(item.date).toString().split(" ")[1] }}
                      </span>
                    </li>
                  </ul>
                  <div
                    v-for="(item, index) in store.store_data"
                    class="tabDate"
                    :key="index"
                  >
                    <div
                      v-if="
                        item.selectedDate == true && store.isSchedule == true
                      "
                    >
                      <div class="tabDetail tabActive">
                        <!-- slotActive -->
                        <div
                          class="timeSlot"
                          :class="{
                            slotDisable:
                              !time.is_available ||
                              selectedSlots.some((x) => {
                                if (
                                  x.store_id == store.store_id &&
                                  x.slot.time_slot == 'Express Delivery'
                                ) {
                                  return true;
                                }
                              }),
                            slotActive: selectedSlots.some(
                              (x) => x.slot === time
                            ),
                          }"
                          v-for="(time, i) in item.slots"
                          :key="i"
                          @click="
                            selectTimeSlot({
                              store_id: store.store_id,
                              slot: time,
                              date: item.date,
                            })
                          "
                        >
                          {{ time.time_slot }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="
                      store.seller_delivery != '' &&
                      store.seller_delivery != null
                    "
                  >
                    <span class="seller__info"
                      >{{ store.seller_delivery }}
                      <span
                        class="link"
                        @click="sellerViews(store.order_quote_id)"
                        >View Details</span
                      ></span
                    >
                  </div>
                </div>
                <div
                  v-else-if="
                    store.seller_delivery != '' && store.seller_delivery != null
                  "
                >
                  <span class="seller__info"
                    >{{ store.seller_delivery
                    }}<span
                      class="link"
                      @click="sellerViews(store.order_quote_id)"
                      >View Details</span
                    ></span
                  >
                </div>
                <div v-else>
                  <span class="seller__info_empty"></span>
                </div>
              </div>
              <div v-if="store.prescription_required == true">
                <div>
                  <h3 style="color: #ba2126">
                    Upload Prescription<span
                      ><h5>(Upload Images Only)</h5></span
                    >
                  </h3>
                </div>
                <input
                  class="uploadPrescribe"
                  id="prescription"
                  type="file"
                  @change="
                    uploadPrescriptionFile({
                      $event,
                      store_id: store.store_id,
                      order_quote_id: store.order_quote_id,
                      callback:false
                    })
                  "
                  accept="image/*"
                  multiple
                />
                <div v-if="selectedFile.length > 0">
                  <div
                    v-for="(item, index) in showImages(store.store_id)"
                    :key="index"
                  >
                    <span v-if="item.name.length > 15"
                      >{{ item.name.substring(1, 8) }}....{{
                        item.name.substring(
                          item.name.length - 5,
                          item.name.length
                        )
                      }}</span
                    >
                    <span v-else>{{ item.name }}</span>
                    <span>
                      <i
                        class="fa fa-times"
                        @click="removePrescribedFile(store.store_id, index)"
                      ></i>
                    </span>
                  </div>
                </div>
              </div>

              <div v-if="store.prescription_required == true" class="mt-4">
                <div>
                  <h3>
                    Do not have a prescription? Request a callback from the store.
                  </h3>
                </div>
                <div 
                class="timeSlot"
                style="border-bottom: 0.5px solid #efefef"
                :class="{
                      slotActive: checkstatus(store.store_id),
                    }"
              
                @click="uploadPrescriptionFile({
                      $event,
                      store_id: store.store_id,
                      order_quote_id: store.order_quote_id,
                      callback:true
                    })">
                    Request Callback
                </div>
                
              </div>
            </div>
          </div>

          <div class="col-12 text-right newFixBtn">
            <!-- <div  class="backbutton" v-if="this.page_type === 'delivery'"><img height="20px" width="25px" src="/img/back-icon.png"/></div> -->
            <button
              type="button"
              @click="prevdeliverypage"
              class="scheduleBtn btn text-white px-5 float-left forDesktop"
            >
              Back
              <!-- {{scheduleSelectOption'?'Schedule Delivery':'Continue'}} -->
            </button>
            <button
              type="button"
              :disabled="
                disableNext == true && isSelectedExpressDelivery == false
              "
              @click="saveSlots"
              class="scheduleBtn btn text-white px-5"
            >
              NEXT
              <!-- {{scheduleSelectOption'?'Schedule Delivery':'Continue'}} -->
            </button>
          </div>
        </div>

        <div class="row payment" v-if="this.page_type === 'payment'">
          <div class="col-12 text-center p-0 paymentOptionWrap">
            <div v-if="$root.address.length > 0" class="paymentAddress">
              <p class="addressType">
                Address
                <span>{{
                  $root.address[select_address_index].address_type
                }}</span>
              </p>
              <p class="pt-3">
                {{ $root.address[select_address_index].full_name }},
                {{ $root.address[select_address_index].phone }}
                <br />
                {{ $root.address[select_address_index].street_address }},
                {{ $root.address[select_address_index].city }},
                {{ $root.address[select_address_index].state_name }}
                {{ $root.address[select_address_index].pin_code }}
              </p>
              <a
                href="javascript:void(0)"
                @click="changePageType('shipping')"
                class="section-back-btn"
                >Edit</a
              >
            </div>

            <h3
              class="section-title font-medium"
              v-if="
                this.$root.storeCredit > 0 && paymentOptions.includes('credits')
              "
            >
              Use WNDW Credits
            </h3>
            <div
              class="paymentWrap"
              v-if="
                this.$root.storeCredit > 0 && paymentOptions.includes('credits')
              "
            >
              <div
                class="paymentCard storeCredit newCreditStore m-1"
                :class="{ avail: useStoreCredit }"
                @click="useCredits"
              >
                <span class="float-left wndCredit" >
                  <p>WNDW Credits</p>
                  <small
                    >Total Available Credits:
                    {{ this.$root.storeCredit | formatMoney }}</small
                  >
                </span>
                <span class="float-right text-right">
                  <p>YOU USE</p>
                  <small style="color: #349e44">{{
                    redeemablePoint | formatMoney
                  }}</small>
                </span>
              </div>
            </div>
            <h3
              v-if="
                this.$root.storeCredit < this.$root.cart_total ||
                !useStoreCredit
              "
              class="section-title font-medium my-3"
            >
              Choose Payment Mode
            </h3>
            <div class="paymentWrap">
              <div
                v-ripple
                class="paymentCard prePaidCard m-1"
                @click="payment_method = 'razorpay'"
                :class="{ avail: payment_method == 'razorpay' }"
                v-if="
                  (this.$root.storeCredit < this.$root.cart_total ||
                    !useStoreCredit) &&
                  paymentOptions.includes('razorpay')
                "
              >
                CREDIT CARD/DEBIT CARD/NET BANKING/WALLET/UPI
              </div>
              <div
                v-ripple
                class="paymentCard m-1"
                @click="payment_method = 'cod'"
                :class="{ avail: payment_method == 'cod' }"
                v-if="
                  (this.$root.storeCredit < this.$root.cart_total ||
                    !useStoreCredit) &&
                  paymentOptions.includes('cod')
                "
              >
                Cash on Delivery (COD)
              </div>
              <div
                v-ripple
                class="paymentCard storeCard m-1"
                @click="payment_method = 'credits'"
                v-if="
                  this.$root.storeCredit > this.$root.cart_total &&
                  useStoreCredit
                "
              >
                <h4>No Additional Amount to pay</h4>
                <p>
                  You have no outstanding amount to pay. Click "Place Order"
                  button to place this order.
                </p>
              </div>
            </div>
          </div>
          <div class="col-12 text-right p-0 paymentOptionWrap">
            <button
              type="button"
              @click="prevpaymentpage"
              class="scheduleBtn btn text-white px-5 float-left forDesktop"
            >
              Back
              <!-- {{scheduleSelectOption'?'Schedule Delivery':'Continue'}} -->
            </button>
            <div class="py-3 newFixBtn">
              <button
                v-if="!loader"
                type="button"
                class="scheduleBtn btn text-white px-5"
                @click="place_order()"
                :disabled="!payment_method || isPlaceOrder"
              >
                {{
                  payment_method == "cod" ||
                  (this.$root.storeCredit > this.$root.cart_total &&
                    useStoreCredit)
                    ? "Place Order"
                    : "Pay Now"
                }}
              </button>
              <button
                disabled
                v-if="loader"
                type="button"
                class="scheduleBtn btn text-white px-5"
              >
                {{
                  payment_method == "cod" ||
                  (this.$root.storeCredit > this.$root.cart_total &&
                    useStoreCredit)
                    ? "Place Order"
                    : "Pay Now"
                }}
              </button>
            </div>
            <div class="payment_icons forDesktop">
              <img src="/img/payment-options-img.jpg" />
            </div>
          </div>
        </div>
      </div>
      
      <div class="col-md-4 col-sm-12 col-xs-12 opc-sidebar" >
        <div class="summary_header">
          <span class="summary-title font-medium">Order Summary</span>
          <span class="edit-cart">
            <a href="/cart.html" class>Edit Cart</a>
          </span>
        </div>
        <div class="discount-container checkout_sidebar">
          <div>
            <div class="coupon-container">
              <p class="coupon-heading pull-left font-medium">
                Apply Coupons
                <!---->
              </p>

              <div class="actions-toolbar pull-right">
                <button
                  type="button"
                  class="coupon-popup add-coupon"
                  @click="toggleCoupon()"
                >
                  <span>Apply</span>
                </button>
              </div>
            </div>
            <!-- <div class="coupon-container " v-if="applied_coupon_arr.length>0">
						<div  v-for="coupon in applied_coupon_arr" :key="coupon">
						<p class="coupon-heading pull-left font-medium  pt-4" >
							Applied Coupons {{coupon}}
					
						</p>

						<div  class="actions-toolbar pull-right mt-2">
							
								<a style="cursor:pointer" @click="remove_coupon(coupon)">Remove Coupon</a>
						</div>
						</div>
						</div>-->
          </div>
          <div class="discount-message"></div>
        </div>
        <div class="content">
          <div class="minicart-items-wrapper overflowed">
            <ol class="minicart-items">
              <li
                class="product-item"
                v-for="(items, i) in this.$root.cart_product"
                :key="i"
              >
                <span class="product-image pull-left">
                  <span class="image-wrapper">
                    <responsive-image
                      width="70"
                      v-bind:desktop="`${$root.image_url_c}inside/90x45/${items.image}`"
                      v-bind:tab="`${$root.image_url_c}inside/60x28/${items.image}`"
                      v-bind:mobile="`${$root.image_url_c}inside/65x28/${items.image}`"
                      v-bind:default_image="`${$root.image_url_c}inside/80x25/${items.image}`"
                    />
                  </span>
                </span>
                <div class="item-details checkout-summmry-item">
                  <div class="product-item-inner">
                    <div class="product-item-name-block">
                      <div class="product-item-name font-medium">
                        {{ items.name }}
                        <!-- <div class="storeName">
															(<em>from</em>
															<span> {{ items.store_name }})</span>
												</div>-->
                        <p
                          class="section-error-message"
                          v-if="items.qty > items.max_qty"
                        >
                          Requested quantity not available.
                        </p>
                      </div>

                      <div
                        class="details-qty details-size float-left mr-4"
                        v-if="items.size"
                      >
                        <span class="label">
                          <span>Size :</span>
                        </span>
                        <span class="value" v-text="items.size"></span>
                      </div>
                      <div class="details-qty">
                        <span class="label">
                          <span>Qty :</span>
                        </span>
                        <span class="value" v-text="items.qty"></span>
                      </div>
                    </div>
                    <div class="subtotal">
                      <div class="price">
                        <p>
                          <span
                            class="price font-bold"
                            style="padding-right: 5px"
                          >
                            <span class="value">{{
                              items.selling_price | formatMoney
                            }}</span>
                          </span>
                          <span
                            class="old-price"
                            style="padding-right: 0px"
                            v-if="items.selling_price != items.price"
                            >{{ items.price | formatMoney }}</span
                          >
                          <span
                            class="discount_percent font-bold"
                            v-if="items.selling_price != items.price"
                            >{{
                              $root.percentOff(items.price, items.selling_price)
                            }}</span
                          >
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ol>
          </div>
          <div class="summary-total">
            <div class="summaryDetail">
              <div class="total">TOTAL MRP</div>
              <div class="amount text-right">
                {{ this.$root.summary.totalMRP | formatMoney }}
              </div>
            </div>
            

            <div class="summaryDetail">
              <div class="total">Discount on MRP</div>
              <div class="amount mrp text-right">
                <span>{{ this.$root.summary.discountMRP | formatMoney }}</span>
              </div>
            </div>
            <!-- <div class="summaryDetail">
							<div class="total">Subtotal </div>
							<div class=" mrp text-right">
								<span >
									{{ this.$root.cart_subtotal | formatMoney }}
								</span>
								
							</div>
						</div>-->
            <div class="summaryDetail">
              <div class="total">Shipping Charges</div>
              <div class="mrp text-right">
                <span v-if="this.$root.shipping_charge">{{
                  this.$root.shipping_charge | formatMoney
                }}</span>
                <span v-else> <span>&#8377;</span> 0 </span>
              </div>
            </div>

            <div class="summaryDetail">
              <div class="total">Coupon Discount</div>
              <div class="coupon-container">
                <span
                  v-if="this.$root.discount_amount"
                  class="amount mrp text-right"
                  >{{ this.$root.discount_amount | formatMoney }}</span
                >
                <span class="amount mrp text-right" v-else>
                  <span>&#8377;</span> 0
                </span>
              </div>
            </div>
            <div>
              <div class="remove-coupon">
                <p
                  class="coupon-heading pull-left font-medium"
                  v-for="coupon in applied_coupon_arr"
                  :key="coupon.coupon_code + Math.random()"
                  v-if="applied_coupon_arr.length > 0"
                >
                  <a style="cursor: pointer" @click="remove_coupon(coupon)">
                    <span>{{ coupon.coupon_code }}</span>
                    <i class="fa fa-times-circle"></i>
                  </a>
                </p>
              </div>
            </div>
            <!-- <div class="summaryDetail">
							<div class="total">Platform Handling Fee</div>
							<div class="amount text-right">
								Rs. 99
							</div>
						</div>-->
            <div class="summaryDetail total">
              <div class="grandTotal">
                <strong>Total Amount</strong>
              </div>
              <div class="totalAmount text-right">
                <strong>{{ this.$root.cart_total | formatMoney }}</strong>
              </div>
            </div>

            <div class="summaryDetail" v-if="this.useStoreCredit">
              <div class="total">WNDW Credit Used</div>
              <div class="amount mrp text-right">
                <span v-if="this.$root.storeCredit > this.$root.cart_total">-{{
                  this.$root.cart_total | formatMoney
                }}</span>
                <span v-else>-{{ this.$root.storeCredit | formatMoney }}</span>
              </div>
            </div>
            <div class="summaryDetail" v-if="this.useStoreCredit">
              <div class="total">Net Payable</div>
              <div class="amount mrp text-right"> 
                <span>
                  
                  {{this.netPayable | formatMoney}}
                  </span>
               
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Order Details Popup -->
    <div
      class="modal"
      v-bind:class="[this.viewDetailspopup ? '' : 'active']"
      id="coupon-modal"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header p-4">
            <h4 class="modal-title font-bold">Product Information</h4>
            <button type="button" class="close" @click="toggleViewdetails()">
              &times;
            </button>
          </div>
          <!-- Modal body -->
          <div
            class="modal-body p-4"
            style="max-height: 80vh; overflow-y: auto"
          >
            <div class="products__details minicart-items">
              <ul>
                <li
                  class="product-item"
                  v-for="(items, i) in this.viewProductdetails"
                  :key="i"
                >
                  <span class="product-image pull-left">
                    <span class="image-wrapper">
                      <responsive-image
                        width="70"
                        v-bind:desktop="`${$root.image_url_c}inside/90x45/${items.image}`"
                        v-bind:tab="`${$root.image_url_c}inside/60x28/${items.image}`"
                        v-bind:mobile="`${$root.image_url_c}inside/65x28/${items.image}`"
                        v-bind:default_image="`${$root.image_url_c}inside/80x25/${items.image}`"
                      />
                    </span>
                  </span>
                  <div class="item-details">
                    <div class="product-item-name font-medium">
                      {{ items.name }}
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Order Details Popup End -->

    <!--apply coupon popup loader-->
    <div
      class="modal"
      style="z-index: 1100"
      v-bind:class="[this.coupon_process ? 'active' : '']"
      id="coupon-modal"
    >
      <loading-icon
        class="loading-icon applyCouponloader"
        name="ball-clip-rotate-multiple"
        color="red"
        scale="1"
      ></loading-icon>
    </div>

    <div
      class="modal"
      v-bind:class="[this.coupon_popup ? '' : 'active']"
      id="coupon-modal"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header p-4">
            <h4 class="modal-title font-bold">APPLY COUPON</h4>
            <button type="button" class="close" @click="toggleCoupon()">
              &times;
            </button>
          </div>
          <!-- Modal body -->
          <div
            class="modal-body p-4"
            style="max-height: 80vh; overflow-y: auto"
          >
            <div class="couponsForm-base-couponsPageContainer">
              <div role="tablist">
                <div
                  class="block discount active"
                  id="block-discount"
                  data-collapsible="true"
                  role="tab"
                  aria-selected="true"
                  aria-expanded="true"
                  tabindex="0"
                >
                  <div id="discount-coupon-form">
                    <div class="fieldset coupon">
                      <input
                        type="hidden"
                        name="remove"
                        id="remove-coupon"
                        value="0"
                      />
                      <input
                        name="form_key"
                        type="hidden"
                        value="KsjDpCfcgYHw5MOG"
                      />
                      <div class="couponsForm-base-formContainer">
                        <div class="couponsForm-base-textInputContainer">
                          <input
                            id="coupon_code"
                            class="couponsForm-base-textInput"
                            v-model="applied_coupon"
                            name="coupon_code"
                            placeholder="Enter coupon code"
                            autocomplete="off"
                          />
                          <button
                            v-ripple
                            @click="apply_coupon_typed()"
                            class="
                              action
                              apply
                              primary
                              couponsForm-base-applyButton
                              font-medium
                            "
                            id="applycoupon"
                            type="button"
                          >
                            Apply
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="couponsForm-base-errorMessage"></div>
              </div>

              <div class="couponsForm-base-boundary"></div>
              <div
                class="couponsForm-base-container"
                v-if="this.coupon_list.length != 0"
              >
                <div class="couponsForm-base-couponsTitle">
                  Best coupon for you
                </div>
                <div
                  v-for="(store, storeName) in this.coupon_list"
                  :key="storeName"
                >
                  <div class="store-name">{{ storeName }}</div>
                  <div
                    class="
                      coupon-base-validCoupon coupon-base-validCouponContainer1
                    "
                    v-for="(item, index) in store"
                    :key="`coupon${index}`"
                  >
                    <div class="coupons-container">
                      <div class="coupon-base-couponCode font-bold">
                        {{ item.coupon_code }}
                      </div>
                      <div
                        v-if="checkAppliedCoupon(item) == true"
                        class="coupon-base-apply font-medium"
                        @click="apply_coupon(item)"
                      >
                        <i
                          v-if="couponProcessing.includes(item)"
                          class="fa fa-spinner fa-spin"
                        ></i>
                        <span v-else>Apply</span>
                      </div>
                      <div class="coupon-base-benefit">
                        <span class="coupon-base-amount font-medium">
                          <span class="icon-rupee coupon-base-rupeeIcon"></span>
                          {{ item.display_message }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="couponsForm-base-container">
                <div class="text-center p-5">No Coupons available</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- address edit -->

    <div
      id="coupon-modal"
      v-if="!address_popup"
      class="modal"
      v-bind:class="[address_popup ? '' : 'active']"
    >
      <div class="overFlow" @click="closeEditAddress()"></div>
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title font-bold">Edit Address</h4>
            <button type="button" class="close" @click="closeEditAddress()">
              ×
            </button>
          </div>
          <div class="modal-body">
            <form class="opc-section">
              <div
                class="field full-name"
                v-bind:class="{
                  success: this.name_error == '',
                  error: this.name_error != '',
                }"
              >
                <input
                  class="input-text form-control"
                  v-model="edit.name"
                  placeholder="Full Name"
                  autocomplete="off"
                  @keyup="edit_name"
                  type="text"
                  name="full_name"
                  required
                />
                <p class="size_error" v-text="this.name_error"></p>
              </div>
              <div
                class="field street-address"
                v-bind:class="{
                  success: this.address_error == '',
                  error: this.address_error != '',
                }"
              >
                <input
                  class="input-text form-control"
                  v-model="edit.address"
                  placeholder="Street Address"
                  autocomplete="off"
                  @keyup="edit_address"
                  type="text"
                  name="street_address"
                  required
                />
                <p class="size_error" v-text="this.address_error"></p>
              </div>
              <div
                class="field pin-code"
                v-bind:class="{
                  success: this.pin_code_error == '',
                  error: this.pin_code_error != '',
                }"
              >
                <input
                  class="input-text form-control"
                  type="number"
                  autocomplete="off"
                  placeholder="PIN Code"
                  @keyup="edit_pin_code"
                  v-model="edit.pin_code"
                  name="pin_code"
                  id="postcode"
                  maxlength="6"
                  required
                />
                <p class="size_error" v-text="this.pin_code_error"></p>
              </div>

              <div
                class="field city"
                v-bind:class="{
                  success: this.city_error == '' && this.edit.cityselect != '',
                  error: this.city_error != '',
                }"
              >
                <input
                  class="input-text form-control"
                  type="text"
                  placeholder="State"
                  autocomplete="off"
                  v-model="edit.city"
                  name="state"
                  id="state"
                  required
                  disabled
                />
                <p class="size_error" v-text="this.city_error"></p>
              </div>
              <div
                class="field state"
                v-bind:class="{
                  success: this.state_error == '',
                  error: this.state_error != '',
                }"
              >
                <input
                  class="input-text form-control"
                  type="text"
                  placeholder="State"
                  autocomplete="off"
                  v-model="edit.state"
                  name="state"
                  id="state"
                  required
                  disabled
                />
              </div>
              <div
                class="field receiver-phone"
                v-bind:class="{
                  success: this.phone_error == '',
                  error: this.phone_error != '',
                }"
              >
                <input
                  class="input-text form-control"
                  maxlength="10"
                  placeholder="Mobile Number"
                  autocomplete="off"
                  @keyup="edit_phone"
                  v-model="edit.phone"
                  type="text"
                  name="phone"
                  required
                />
                <p class="size_error" v-text="this.phone_error"></p>
              </div>
              <div class="field address_type_container">
                <label>Select Address Type</label>
                <div class="row">
                  <div class="col-4">
                    <label for="home">
                      <input
                        type="radio"
                        @change="edit_address_type_change($event)"
                        id="home"
                        name="Type"
                        value="home"
                        :checked="edit.address_type == 'home'"
                      />
                      Home
                    </label>
                  </div>
                  <div class="col-4">
                    <label for="office">
                      <input
                        type="radio"
                        @change="edit_address_type_change($event)"
                        id="office"
                        name="Type"
                        value="office"
                        :checked="edit.address_type == 'office'"
                      />Office
                    </label>
                  </div>
                  <div class="col-4">
                    <label
                      class="ml-3"
                      for="others"
                      :class="{
                        addressTypeActive: this.edit.address_type == 'others',
                      }"
                    >
                      <input
                        type="radio"
                        @change="edit_address_type_change($event)"
                        id="others"
                        name="Type"
                        value="others"
                        :checked="this.edit.address_type == 'others'"
                      />
                      Others
                    </label>
                  </div>
                  <div
                    class="col-4 offset-8"
                    v-if="edit.address_type == 'others'"
                  >
                    <input
                      v-model="otherAddressType"
                      type="text"
                      class="form-control w-100"
                    />
                  </div>
                </div>
              </div>
              <div class="field submitf">
                <button
                  type="button"
                  @click="checkEditAddress"
                  v-ripple
                  class="continue"
                >
                  <span>Update Address</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal size-guide-popup-container"
      v-bind:class="{ active: this.isMap === false }"
      id="coupon-modal"
      v-if="!this.isMap"
    >
      <div
        class="overFlow"
        @click="
          isMap = true;
          isEditAddress = false;
        "
      ></div>
      <!-- @click="close_store_popup()" -->
      <div class="modal-dialog">
        <div
          class="modal-content"
          style="border-radius: 6px !important; overflow: hidden"
        >
          <div class="modal-body p-0">
            <!-- class="close" -->
            <!-- @click="close_store_popup()" -->

            <div v-if="!this.isMap">
              <GmapMap
                id="map"
                :center="center"
                :zoom="15"
                :options="{
                  zoomControl: true,
                  mapTypeControl: false,
                  scaleControl: false,
                  streetViewControl: false,
                  rotateControl: false,
                  fullscreenControl: false,
                  disableDefaultUi: false,
                  componentRestrictions: {
                    country: ['in'],
                  },
                }"
                map-type-id="terrain"
                style="width: 100%; height: 350px"
                @click="mark"
              >
                <GmapMarker
                  v-for="(marker, i) in markers"
                  :position="marker.position"
                  :clickable="true"
                  :draggable="true"
                  :key="i"
                  :icon="markerOptions"
                  @dragend="setCenter"
                />
              </GmapMap>

              <h4 class="mapPopHeading p-3">
                Set your delivery location
                <button
                  type="button"
                  class="close"
                  style
                  @click="
                    isMap = true;
                    isEditAddress = false;
                  "
                >
                  &times;
                </button>
              </h4>

              <p v-if="isEditAddress" class="locationAddress">
                {{ this.edit.address }}, {{ this.edit.city }},
                {{ this.edit.pin_code }}
              </p>
              <p v-else class="locationAddress">
                {{ this.user.address }}, {{ this.user.city }},
                {{ this.user.pin_code }}
              </p>
              <div v-if="isEditAddress" class="form-row">
                <input
                  type="text "
                  class="locationAddress form-control"
                  @keyup="checkEditFlatNumber"
                  style="width: 40%"
                  v-model="this.edit.flat"
                  placeholder="House No./Flat No./Floor"
                />
                <input
                  type="text "
                  class="locationAddress form-control"
                  @keyup="checkEditFlatNumber"
                  style="width: 45%"
                  v-model="this.edit.landmark"
                  placeholder="LandMark"
                />
              </div>
              <div v-else class="form-row">
                <input
                  type="text "
                  class="locationAddress form-control"
                  @keyup="checkFlatNumber"
                  style="width: 40%"
                  v-model="user.flat"
                  placeholder="House No./Flat No./Floor"
                />
                <input
                  type="text "
                  class="locationAddress form-control"
                  @keyup="checkFlatNumber"
                  style="width: 45%"
                  v-model="user.landmark"
                  placeholder="LandMark"
                />
              </div>
              <p v-show="errorFlat" class="text-danger ml-3">{{ errorFlat }}</p>

              <button
                type="submit"
                class="btn shippingBtn text-white float-right mx-4 mb-3"
                @click.prevent="confirmAndProceed()"
              >
                Confirm and Proceed
              </button>
            </div>

            <!-- <Login /> -->
          </div>
        </div>
      </div>
    </div>
    <!-- Un delivered Items popup  start-->
    <div
      class="modal"
      v-bind:class="[isDropCartItemsPopup ? 'active' : '']"
      id="coupon-modal"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header p-4">
            <h4 class="modal-title font-bold">Note</h4>
            <button
              type="button"
              class="close"
              @click="isDropCartItemsPopup = false"
            >
              &times;
            </button>
          </div>
          <!-- Modal body -->
          <div
            class="modal-body p-4"
            style="max-height: 80vh; overflow-y: auto"
          >
            <div class="couponsForm-base-couponsPageContainer">
              <div role="tablist">
                <div
                  class="block discount active"
                  id="block-discount"
                  data-collapsible="true"
                  role="tab"
                  aria-selected="true"
                  aria-expanded="true"
                  tabindex="0"
                >
                  <div id="discount-coupon-form">
                    <div class="fieldset coupon"></div>
                  </div>
                </div>
                <div class="couponsForm-base-errorMessage"></div>
              </div>
              <div class="couponsForm-base-boundary"></div>
              <div class="couponsForm-base-container">
                <div class="couponsForm-base-couponsTitle pt-0">
                  Items of below stores are not available on this address
                </div>
                <div v-for="store in dropCartItemsStores" :key="store">
                  <div class="store-name py-2">{{ store[0].store_name }}</div>
                </div>
              </div>
              <div class="couponsForm-base-container">
                <div class="text-center p-5">
                  <button
                    v-ripple
                    @click="RemoveAllUndeliveredItems"
                    class="continue float-right themeBtn"
                    type="button"
                  >
                    <span>Remove All and Proceed</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Un delivered Items popup end -->
  </div>

  <!-- new -->
</template>
<style scoped>
@media screen and (max-width: 767px){
.deliveryotp {
    font-size: var(--font-size-regular);
}
}
.deliveryotp{
padding:12px
}
.deliveryotptext{
  margin-left: 30px;
    position: relative;
    top: -3px;
}
.deliveryotp::before{
  content: '';
    position: absolute;
    left: 25px;
    width: 20px;
    height: 20px;
    border: 1px solid #ccc;
    font-size: 14px;
    line-height: 18px;
    text-align: center;
}
.deliveryotp.otpselected::before{
  text-align: center;
    content: "\f00c";
    font: normal normal normal 12px/1 FontAwesome;
    position: absolute;
    left: 25px;
    width: 20px;
    height: 20px;
    border: 1px solid #ccc;
    font-size: 14px;
    line-height: 18px;
    background-color: var(--main-color);
    color: #fff;
    border-color: var(--main-color);
}
.newCreditStore::before {
  top: 19px !important;
}
.paymentCard.storeCredit.newCreditStore.m-1 .wndCredit {
  margin-left:40px;
}
.applyCouponloader {
  position: relative;
  top: 50%;
  left: 50%;
}
.addressType input {
  opacity: 0;
  margin-left: -10px;
}
.addressType i {
  font-size: var(--font-size-heading);
  color: #666;
}
.addressType .fa-briefcase {
  font-size: 15px;
}
.addressType label {
  border: 2px solid #dddddd;
  padding: 5px 12px;
  cursor: pointer;
}
.addressType label:hover {
  border: 2px solid var(--main-color);
}
.addressType label.addressTypeActive {
  border: 2px solid var(--main-color);
}
#coupon-modal .close {
  margin-right: 0px !important;
  z-index: 999;
  position: static;
  opacity: 1;
  font-size: 25px;
}
.shipping-address-section .new-address-btn {
  margin-bottom: 10px;
  margin-top: 10px;
}
.mapPopHeading {
  margin: 15px 0;
  font-weight: bold;
  margin-bottom: 15px;
}
.locationAddress {
  padding: 10px;
  border: 1px solid rgb(207, 207, 207);
  border-radius: 6px;
  cursor: pointer;
  margin: 0 15px;
  margin-bottom: 18px;
  font-family: "lhmSemiBold";
}
.locationAddress::before {
  content: "\2713";
  width: 20px;
  height: 20px;
  border: 1px solid var(--main-color);
  float: left;
  margin-right: 8px;
  padding-left: 3px;
  border-radius: 50px;
  color: var(--main-color);
}
.checkout-Skeleton .Skeleton1 {
  height: 70px;
  display: block;
  margin-bottom: 40px;
}
.checkout-Skeleton .Skeleton2 {
  height: 50px;
  display: block;
  width: 80%;
  margin: 0 auto;
  margin-bottom: 10px;
  

}

.checkout-Skeleton .Skeleton3 {
  display: block;
  height: 500px;
  width: 80%;
  margin: 0 auto;
}
.checkout_header {
  min-height: 50px;
}
@media screen and (max-width: 767px) {

  .newCreditStore::before {
    left: 5px;
  }
  .paymentCard.storeCredit.newCreditStore.m-1 .wndCredit {
  margin-left:20px;
}
  .opc-Skeleton {
    display: none;
  }
.checkout-Skeleton .Skeleton1 {
  height: 50px;
  margin-bottom: 10px;
  }
  .checkout-Skeleton .Skeleton2 {
 width: 95%;

   }

.checkout-Skeleton .Skeleton3 { 
  height: 500px;
 width: 95%;

}
  #coupon-modal .close {
    margin-top: -10px !important;
  }
}
</style>
<script>
import axios from "axios";
import Login from "../components/Login";
import GoogleMap from "../GoogleMap";
import StoreProductVue from "./StoreProduct.vue";

export default {
  name: "Checkout",

  metaInfo: {
    title: "Checkout",
    meta: [
      {
        name: "description",
        content:
          "Online fashion shopping destination for the modern women. Buy latest collection of online ethnic wear for women’s, W Kurtas, dresses, bottom wear, tops, palazzos, culottes, skirts, drapes and more.",
      },
      {
        property: "keywords",
        content:
          "Online Shopping for Women,  W for Woman, women’s dresses online, buy women’s dresses online",
      },
    ],
  },
  components: {
    Login,
    GoogleMap,
  },
  computed: {
    redeemablePoint() {
      var points = 0;
      if (this.$root.cart_total < this.$root.storeCredit) {
        points = this.$root.cart_total;
        // if(this.shiping_charges) {
        //     points = points - this.shiping_charges
        // }
      } else {
        points = this.$root.storeCredit;
      }
      return points;
    },
    disableNext() {
      let flag = false;
      let count = 0;
      if (this.cartWiseSlots.length) {
        this.cartWiseSlots.forEach((element) => {
          if (element.store_data.length == 0) {
            count++;
          }
        });
      }
      if (this.cartWiseSlots.length - count == this.selectedSlots.length) {
        return flag;
      } else {
        flag = true;
        return flag;
      }
    },
  },
  data() {
    return {
      otpquotes:[],
      otpRequired:[],
      totalpres:0,
      getCartChecoutLoader : true,
      accountLoader:true,
      netPayable:0,
      coupon_process: false,
      couponProcessing: [],
      isPrescription: false,
      selectedFile: [],
      is_prescription: false,
      loader: false,
      isPlaceOrder: false,
      errorFlat: "",
      otherAddressType: "",
      isSelectedExpressDelivery: false,
      selectedSlots: [],
      cartWiseSlots: {
        201: [
          {
            "2021-05-12": [
              {
                is_available: false,
                slot_id: 1235,
                time_slot: "12AM - 2PM",
                time_slot_id: 3,
                store_data: [],
              },
            ],
          },
        ],
      },
      isLoading: false,
      isEditAddress: false,
      expressSlot: {},
      isExpress: 0,
      isExpressDelivery: false,
      isDropCartItemsPopup: false,
      dropCartItemsStores: [],
      markerOptions: {
        url: "/img/pin-map-location.png",
        size: { width: 58, height: 50, f: "px", b: "px" },
        scaledSize: { width: 55, height: 50, f: "px", b: "px" },
      },
      applied_coupon_arr: [],
      isMap: true,
      error: "",
      center: {
        lat: parseInt(this.$root.location.lat),
        lng: parseInt(this.$root.location.long),
      },
      markers: [
        {
          position: {
            lat: parseInt(this.$root.location.lat),
            lng: parseInt(this.$root.location.long),
          },
        },
      ],
      address_popup: true,
      edit: {
        flat: "",
        landmark: "",
        address_id: "",
        name: "",
        address: "",
        pin_code: "",
        area: "",
        areaselect: "",
        city: "",
        cityselect: "",
        state: "",
        phone: "",
        address_type: "",
        default: "",
      },
      places: [],
      currentPlace: null,
      firstAvailableSlot: {},
      scheduleSelectOption: false,
      useStoreCredit: false,
      coupon_list: [],
      coupon_popup: true,
      viewDetailspopup: true,
      viewProductdetails: [],
      gift_card: "",
      selectedSlot: { date: "" },
      page_type: "",
      back_page_type: "",
      send_otp_btn: true,
      mobile_number: "",
      mobile_error: "",
      address_show_hide: false,
      address_show_hide_length: 1,
      gift_amount: "",
      apply_gift_card_code: "",
      mobile: false,
      timeSlots: [],
      old_customer: false,
      last_address: "",
      g_checkout_page: true,
      c_login: false,
      otp_number: "",
      otp_error: "",
      product_type: "",
      select_address_index: 0,
      otp: false,
      payment_method: "",
      gift_s_m: "",
      gift_e_m: "",
      coupon_s_m: "",
      coupon_e_m: "",
      address_error: "",
      name_error: "",
      pin_code_error: "",
      selectedDate: "",
      selectedStore: "",
      pin_code_success: "",
      cod_msg_show: false,
      cod_msg: "",
      shipping_charges: "",
      cod_charges: "",
      city_error: "",
      state_error: "",
      phone_error: "",
      email_error: "",
      address_type_error: "",
      net_amount: "",
      cod_hide: true,
      cus_cod_hide: true,
      applied_coupon: "",
      cod_delivery_msg: "",
      selected_address_pincode: "",
      timeSlot: [
        {
          is_available: false,
        },
      ],
      products: [],
      isOtp: false,
      user: {
        flat: "",
        landmark: "",
        name: "",
        address: "",
        pin_code: "",
        city: "",
        state: "",
        phone: "",
        email: "",
        address_type: "",
      },
      payu_form: {
        action: "",
        key: "",
        hash: "",
        amount: "",
        firstname: "",
        email: "",
        phone: "",
        productinfo: "",
        txnid: "",
        udf1: "",
        surl: "",
        furl: "",
      },
      razorpay_form: {
        key: "",
        id: "",
        amount: "",
        name: "",
        description: "",
        image: "",
        cv: "",

        prefill: {
          name: "",
          email: "",
          contact: "",
        },
        notes: {
          id: "",
        },
        theme: {
          color: "",
        },
      },
      paymentOptions: [],
      resend_otp_time: 60,
      free_offer: false,
      free_offer_sku: [
        "19AUW9HB0002-43168",
        "19AUW9HB0002-43167",
        "20FEW93098-43164",
        "20FEW93098-43163",
        "20FEW93096-43087",
        "20FEW93096-43086",
        "20FEW93095-43085",
        "20FEW93094-43084",
        "20FEW93094-43083",
        "20FEW93090-43162",
        "20FEW93090-43161",
        "20FEW93089-43280",
        "20FEW93089-43159",
        "20FEW93089-43158",
        "20FEW93089-43157",
        "20FEW93089-43156",
        "20FEW93089-43155",
        "20FEW93088-43154",
        "20FEW93088-43153",
        "20FEW93087-43152",
        "20FEW93087-43151",
        "20FEW93085-43148",
        "20FEW93085-43147",
        "20FEW93084-43146",
        "20FEW93084-43145",
        "20FEW93084-43144",
        "20FEW93083-43143",
        "20FEW93083-43142",
        "20FEW93082-43141",
        "20FEW93082-43140",
        "20FEW93081-43139",
        "20FEW93081-43138",
        "20FEW93080-43170",
        "20FEW93080-43137",
        "20FEW93080-43136",
        "20FEW93078-43169",
        "20FEW93078-43134",
        "20FEW93078-43133",
        "20FEW93076-43131",
        "20FEW93075-43130",
        "20FEW93075-43129",
        "20FEW93075-43128",
        "20FEW93074-43127",
        "20FEW93074-43126",
        "20FEW93074-43125",
        "20FEW93073-43124",
        "20FEW93072-43123",
        "20FEW93072-43122",
        "20FEW93071-43121",
        "20FEW93070-43120",
        "20FEW93070-43119",
        "20FEW93070-43118",
        "20FEW93069-43117",
        "20FEW93069-43116",
        "20FEW93068-43115",
        "20FEW93067-43114",
        "20FEW93066-43113",
        "20FEW93066-43112",
        "20FEW93066-43111",
        "20FEW93065-43110",
        "20FEW93064-43109",
        "20FEW93064-43108",
        "20FEW93063-43107",
        "20FEW93062-43106",
        "20FEW93060-43104",
        "20FEW93058-43209",
        "20FEW93058-43208",
        "20FEW93058-43207",
        "20FEW93058-43206",
        "20FEW93058-43205",
        "20FEW93058-43103",
        "20FEW93058-43102",
        "20FEW93056-43100",
        "20FEW93056-43099",
        "20FEW93055-43098",
        "20FEW93055-43097",
        "20FEW93054-43096",
        "20FEW93054-43095",
        "20FEW93053-43093",
        "20FEW93053-43092",
        "20FEW93052-43091",
        "20FEW93052-43090",
        "20FEW93050-43089",
      ],
    };
  },
  methods: {
    deliveryotp(quoteid){
      if(this.otpRequired.includes(quoteid)){
        let index= this.otpRequired.indexOf(quoteid)
        this.otpRequired.splice(index, 1);
      }
      else{
        this.otpRequired.push(quoteid)
      }
      
    },
    prevdeliverypage() {
      location.reload();
      // store.isSchedule=false
      // this.$router.go(-1)
    },
    prevpaymentpage() {
      this.payment_method = "";
      this.$router.go(-1);
    },
    removePrescription() {
      var form = new FormData();
      form.append("pcart", this.$root.pcart);
      axios
        .post(this.$root.cart_api + "/customer/remove-prescription", form)
        .then((response) => {
          if (response.data.success === true) {
            this.selectedFile=[]
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    removeotprequired(){
       var form = new FormData();
      form.append("order_quotes", JSON.stringify(this.otpquotes));
      axios
        .post(this.$root.cart_api + "/otp/remove-otp-required", form)
        .then((response) => {
          if (response.data.success === true) {
             console.log(response)
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    showImages(id) {
      let images = [];
      let obj = this.selectedFile.findIndex((x) => x.store_id === id);
      if (obj >= 0) {
        images = this.selectedFile[obj].images;
      }
      return images;
    },
    removePrescribedFile(id, index) {
      // let selectedFile = this.selectedFile.map(element => {
      // if(element.store_id === id) {
      // 	if (typeof(element.images) == 'object') {
      // 		return  {store_id: null }
      // 	}
      // 	element.images.splice(index,1)
      // 	return element
      // }

      // });
      // let filtered = selectedFile.filter(x=> x.store_id != null)
      // this.selectedFile = filtered

      let images = [];
      let obj = this.selectedFile.findIndex((x) => x.store_id === id);
      if (obj >= 0) {
        images = [...this.selectedFile[obj].images];
        if (this.selectedFile[obj].images.length == 1) {
          this.selectedFile.splice(obj, 1);
          return;
        } else {
          this.selectedFile[obj].images.splice(index, 1);
        }
      }
    },
    // showSelectedImages(id)
    // {
    // 	let obj = []
    // 	obj = this.selectedFile.find(x=> x.store_id === id)
    // 	return obj.images ? obj.images: []

    // },
    uploadImage(data) {
        
        if(data.images==null){
          let form = new FormData();
          form.append("store_id", data.store_id);
          form.append(
            "order_quote_id",
            data.order_quote_id
          );
          form.append("image", data.images);
          form.append("callback", data.callback);
          axios
            .post(this.$root.cart_api + "/prescription/add-prescription", form)
            .then((response) => {
              if (response.data.success === true) {
                this.selectedFile = [];
              } else {
                this.$toast.error(response.data.message, {
                  position: "top",
                  duration: 4000,
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
        else{
          for(let j=0;j<data.images.length;j++){
                let form = new FormData();
                form.append("store_id", data.store_id);
                form.append(
                  "order_quote_id",
                  data.order_quote_id
                );
                form.append("image", data.images[j]);
                form.append("callback", data.callback);
                axios
                  .post(this.$root.cart_api + "/prescription/add-prescription", form)
                  .then((response) => {
                    if (response.data.success === true) {
                      this.selectedFile = [];
                    } else {
                      this.$toast.error(response.data.message, {
                        position: "top",
                        duration: 4000,
                      });
                    }
                  })
                  .catch((err) => {
                    console.log(err);
                  });
          }
        }
    },
      checkstatus(store){
          let storePresent = this.selectedFile.findIndex(
            (x) => x.store_id === store
            );
            if(storePresent>=0){
              for (var i = 0; i < this.selectedFile.length; i++) {
                if (this.selectedFile[i].store_id == store) {
                  return this.selectedFile[i].callback
                }
              }
            }
            else{
              return false;
            }
      },
    uploadPrescriptionFile(value) {
          if(value.callback==false){
              for(let k=0;k<value.$event.target.files.length;k++){
                  if (
                  value.$event.target.files[k].type == "image/jpeg" ||
                  value.$event.target.files[k].type == "image/jpg" ||
                  value.$event.target.files[k].type == "image/png" ||
                  value.$event.target.files[k].type == "image/Jpeg" ||
                  value.$event.target.files[k].type == "image/JPG" ||
                  value.$event.target.files[k].type == "image/PNG" ||
                  value.$event.target.files[k].type == "image/JPEG" ||
                  value.$event.target.files[k].type == "image/webp" ||
                  value.$event.target.files[k].type == "image/WebP" ||
                  value.$event.target.files[k].type == "image/Png" ||
                  value.$event.target.files[k].type == "image/Jpg"
                ) {
                  
                  }
                  else{
                      this.$toast.error("Upload Images only", {
                        position: "top",
                        duration: 4000,
                      });
                      return;
                    }
              }
              let storePresent = this.selectedFile.findIndex(
              (x) => x.store_id === value.store_id
              );
              if (storePresent >= 0) {
                for (var i = 0; i < this.selectedFile.length; i++) {
                  if (this.selectedFile[i].store_id == value.store_id) {   
                      if(this.selectedFile[i].images==null){
                        this.selectedFile[i].images = [...value.$event.target.files];
                        this.selectedFile[i].callback = false;
                        break;
                      }
                      else{
                        this.selectedFile[i].images = [...this.selectedFile[i].images, ...value.$event.target.files];
                        this.selectedFile[i].callback = false;
                        break;
                      }  
                  }
                }
              }
              else{
                  let selectedFilesForAStore = {
                    store_id: value.store_id,
                    order_quote_id: value.order_quote_id,
                    images: [...value.$event.target.files],
                    callback:false
                  };

                this.selectedFile.push(selectedFilesForAStore);
              }
        }
        else{
              let storePresent = this.selectedFile.findIndex(
              (x) => x.store_id === value.store_id
              );
            
              if (storePresent >= 0) {
                  for (var i = 0; i < this.selectedFile.length; i++) {
                    if (this.selectedFile[i].store_id == value.store_id) {
                      this.selectedFile[i].images = null;
                      this.selectedFile[i].callback = true;
                      break;
                    }
                  }
              }
              else{
                  let selectedFilesForAStore = {
                  store_id: value.store_id,
                  order_quote_id: value.order_quote_id,
                  images: null,
                  callback:true
                };

               this.selectedFile.push(selectedFilesForAStore);
              }
        }
     
    },
    popstateEventAction() {
      if (this.$route.query.page_type) {
        this.page_type = this.$route.query.page_type;
        // this.removePopstateEventAction();
      } else {
        // this.router.push({ path: 'cart' })
        this.removePopstateEventAction();
      }
      // ... some action triggered when the back button is clicked
    },
    removePopstateEventAction() {
      window.removeEventListener("popstate", this.popstateEventAction);
    },
    getPaymentMethods() {
      var form = new FormData();
      form.append("customer_id", this.$root.customer_id);
      form.append("customer_session", this.$root.customer_session);
      form.append("pcart", this.$root.pcart);
      axios
        .post(this.$root.cart_api + "/order/available-methods", form)
        .then((response) => {
          console.log("payment", response.data.data);
          this.paymentOptions = response.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    sellerViews(orderQ) {
      this.viewProductdetails = [];
      var form = new FormData();
      form.append("customer_id", this.$root.customer_id);
      form.append("customer_session", this.$root.customer_session);
      form.append("order_quote_id", orderQ);
      axios
        .post(this.$root.cart_api + "/cart/view-self-fulfilled", form)
        .then((response) => {
          this.viewDetailspopup = false;
          this.viewProductdetails = response.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    checkFlatNumber() {
      if (this.user.flat.length == 0) {
        this.errorFlat = "Please enter Flat/door Number";
      } else {
        this.errorFlat = "";
      }
    },
    checkEditFlatNumber() {
      if (this.edit.flat.length == 0) {
        this.errorFlat = "Please enter Flat/door Number";
      } else {
        this.errorFlat = "";
      }
    },
    selectExpressDelivery() {
      this.isSelectedExpressDelivery = !this.isSelectedExpressDelivery;
      for (let i = 0; i <= this.selectedSlots.length; i++) {
        this.selectedSlots.splice(0, 1);
      }
    },
    storeInTimeSlot(store) {
      let storeFound = this.$root.cart_product.find((x) => x.store_id == store);
      if (storeFound) {
        return storeFound.store_name;
      }
    },
    confirmAndProceed() {
      if (this.isEditAddress) {
        this.checkEditFlatNumber();
      } else {
        this.checkFlatNumber();
      }
      if (this.errorFlat.length) {
        return;
      }
      if (this.isEditAddress) {
        this.isEditAddress = false;
        this.update_address();
      } else {
        this.new_address();
      }
    },
    checkAppliedCoupon(coupon) {
      let status = true;
      this.applied_coupon_arr.forEach((x) => {
        if (x.coupon_code == coupon.coupon_code && x.store == coupon.store) {
          status = false;
        }
      });
      return status;
    },
    goBack() {
      switch (this.page_type) {
        case "delivery":
          this.page_type = "shipping";
          break;
        case "payment":
          this.page_type = "delivery";
          break;
        default:
          this.$router.push("/cart.html");
      }

      // this.page_type = this.back_page_type
    },
    closeEditAddress() {
      (this.isEditAddress = false), (this.address_popup = true);
    },
    RemoveAllUndeliveredItems() {
      var form = new FormData();
      form.append("customer_id", this.$root.customer_id);
      form.append("customer_session", this.$root.customer_session);
      form.append("pcart", this.$root.pcart);
      axios
        .post(this.$root.cart_api + "/cart/drop-carts", form)
        .then((response) => {
          if (response.data.success === true) {
            if (response.data.data.length === 0) {
              this.$router.push("/cart.html");
            }
            this.isDropCartItemsPopup = false;
            if (response.data.undeliverableStores.length === 0) {
              this.$router.push({ query: { page_type: "delivery" } });
              this.page_type = "delivery";
              this.back_page_type = "address";
              this.$root.success_message = response.data.message;
              this.$root.error_message = "";
              this.$root.shipping_charge = response.data.shippingCharge;
              this.$root.cart_total = response.data.grandTotal;
              this.$root.cart_subtotal = response.data.subTotal;
              this.$root.cart_netAmount = response.data.netAmount;
              this.$root.discount_amount = response.data.discountAmount;

              if (response.data.data.length > 0) {
                let ProductsArray = [];
                // Sorting Products array according to SKU

                response.data.data.forEach((cart) => {
                  this.last_address = cart.maddress;
                  ProductsArray = [...ProductsArray, ...cart.products];
                  if (cart.cod_block == "0") {
                    this.cus_cod_hide = true;
                  } else {
                    this.cus_cod_hide = false;
                  }
                  if (cart.product_type == "gift") {
                    this.product_type = "gift";
                    this.payment_method = "payu";
                  }

                  this.$cookies.set(
                    window.location.hostname.substring(10, 4) + "_co_add",
                    cart.maddress,
                    "1y"
                  );

                  if (cart.cookieDelete === 1) {
                    this.$cookies.set(
                      window.location.hostname.substring(10, 4) + "_cart",
                      ""
                    );
                    this.$root.pcart = "";
                  }
                  this.getCartWiseSlots();
                });

                this.$root.cart_product = ProductsArray;
              } else {
                this.$root.cart_product = [];
                this.$root.shipping_charge = response.data.shippingCharge;
                this.$root.cart_total = response.data.grandTotal;
                this.$root.cart_subtotal = response.data.subTotal;
                this.$root.cart_netAmount = response.data.netAmount;
                this.$root.discount_amount = response.data.discountAmount;
              }
              this.$root.page_loader = false;
              // this.$gtm.trackEvent({
              //     event: 'checkout',
              //     category: 'Ecommerce',
              //     action: 'Checkout',
              //     label: '4',
              //     ecommerce: {
              //         checkout: {
              //             'actionField': { 'step': 4, 'option': 'Address selected' },
              //             product: this.$root.gtm_product,
              //         }
              //     }
              // });
            } else {
              this.isDropCartItemsPopup = true;
              this.dropCartItemsStores = [];
              this.dropCartItemsStores = response.data.undeliverableStores;
            }
          
          } else {
            this.$root.error_message = response.data.message;
            this.$root.success_message = "";
            this.$root.page_loader = false;
            window.scrollTo(0, 0);
            if (response.data.customer_session_status == false) {
              this.$cookies.set(
                window.location.hostname.substring(10, 4) + "_customer",
                "",
                "1y"
              );
              this.$cookies.set(
                window.location.hostname.substring(10, 4) + "_cs",
                "",
                "1y"
              );
              this.$root.customer_id = "";
              this.$root.customer_session = "";
              this.$cookies.set(
                window.location.hostname.substring(10, 4) + "_cart",
                "",
                "1y"
              );
              this.$cookies.set(
                window.location.hostname.substring(10, 4) + "_carts",
                "",
                "1y"
              );
              // this.$root.pcart = '';
              this.$root.cart_session = "";
              this.$root.cart_product = [];
              this.$router.push("/login.html");
            }
            if (response.data.cart_session_status == false) {
              this.$cookies.set(
                window.location.hostname.substring(10, 4) + "_customer",
                "",
                "1y"
              );
              this.$cookies.set(
                window.location.hostname.substring(10, 4) + "_cs",
                "",
                "1y"
              );
              this.$root.customer_id = "";
              this.$root.customer_session = "";
              this.$cookies.set(
                window.location.hostname.substring(10, 4) + "_cart",
                "",
                "1y"
              );
              this.$cookies.set(
                window.location.hostname.substring(10, 4) + "_carts",
                "",
                "1y"
              );
              // this.$root.pcart = '';
              this.$root.cart_session = "";
              this.$root.cart_product = [];
              this.$router.push("/cart.html");
            }
          }
        })
        .catch((error) => {
          this.$root.page_loader = false;
          if (error.message === "Network Error") {
            this.$root.error_message =
              "Oops there seems to be some Network issue, please try again.";
          }
          window.scrollTo(0, 0);
        });
    },
    edit_address_address: function (
      id,
      name,
      address,
      area,
      city,
      state,
      pin,
      phone,
      address_type,
      add_default,
      flat_no,
      landmark
    ) {
      this.isEditAddress = true;
      this.edit.address_id = id;
      this.edit.name = name;
      this.edit.address = address;
      this.edit.pin_code = pin;
      this.edit.area = area;
      this.edit.city = city;
      this.edit.state = state;
      this.edit.phone = phone;
      this.edit.flat = flat_no;
      this.edit.landmark = landmark ? landmark : "";
      if (address_type != "home" && address_type != "office") {
        this.edit.address_type = "others";
        this.otherAddressType = address_type;
      } else {
        this.edit.address_type = address_type;
      }

      this.edit.default = add_default;
      this.address_popup = false;
      this.edit_name();
      this.edit_city();
      this.edit_address();
      this.edit_pin_code();
      this.edit_phone();
    },
    edit_name: function () {
      var name = /^(?!\s*$).+/;
      if (this.edit.name.match(name)) {
        this.name_error = "";
      } else {
        this.name_error = "Please enter valid Name";
      }
    },
    edit_city: function () {
      var city = /^(?!\s*$).+/;
      if (this.edit.city.match(city)) {
        this.city_error = "";
      } else {
        this.city_error = "Please enter valid City";
      }
    },
    edit_area: function () {
      var area = /^(?!\s*$).+/;
      if (this.edit.area.match(area)) {
        this.area_error = "";
      } else {
        this.area_error = "Please enter valid Area";
      }
    },
    edit_address: function () {
      var address = /^(?=.*[a-zA-Z]).{10,}$/;
      if (this.edit.address.match(address)) {
        this.address_error = "";
      } else {
        if (this.edit.address.length < 10) {
          this.address_error = "Address should be minimum 10 characters";
        } else {
          this.address_error = "Please enter valid Address";
        }
      }
    },
    edit_email: function () {
      var email =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{3,}))$/;
      if (this.edit.email.match("gmail")) {
        email = /^[a-z0-9](\.?[a-z0-9]){5,}@g(oogle)?mail\.com$/;
      }
      if (this.edit.email.match(email)) {
        this.email_error = "";
      } else {
        this.email_error = "Please enter valid Email";
      }
    },
    edit_pin_code: function () {
      var pin_code = /^([0-9]{6,})+$/;
      if (this.edit.pin_code.match(pin_code)) {
        axios
          .get(this.$root.api_url + `/pim/pimresponse.php`, {
            params: {
              service: "pincheck",
              store: this.$root.store,
              pincode: this.edit.pin_code,
            },
          })
          .then((response) => {
            if (response.data.result == "") {
              this.pin_code_error = "Sorry this pincode is not serviceable.";
            } else {
              this.edit.city = response.data.result.city;
              this.edit.area = response.data.result.area;
              // this.edit.areaselect = Object.keys(response.data.result.area)[0];
              this.edit.city = response.data.result.city;
              this.edit.state = response.data.result.state;
              this.pin_code_error = "";
              this.state_error = "";
              if (response.data.result.city != "") {
                this.city_error = "";
              }
            }
          });
      } else {
        this.pin_code_error = "Please enter valid Pin code";
      }
    },
    edit_phone: function () {
      var phoneno = /^([0-9]{10,})+$/;
      if (this.edit.phone.match(phoneno)) {
        this.phone_error = "";
      } else {
        this.phone_error = "Please enter valid Phone Number";
      }
    },
    user_city: function () {
      var city = /^(?!\s*$).+/;
      if (this.user.cityselect.match(city)) {
        this.city_error = "";
      } else {
        this.city_error = "Please enter valid City";
      }
    },
    user_area: function () {
      var area = /^(?!\s*$).+/;
      if (this.user.areaselect.match(area)) {
        this.area_error = "";
      } else {
        this.area_error = "Please enter valid Area";
      }
    },
    user_address: function () {
      var address = /^(?=.*[a-zA-Z]).{10,}$/;
      if (this.user.address.match(address)) {
        this.address_error = "";
      } else {
        if (this.user.address.length < 10) {
          this.address_error = "Address should be minimum 10 characters";
        } else {
          this.address_error = "Please enter valid Address";
        }
      }
    },

    update_address: function () {
      if (
        this.edit.name != "" &&
        this.edit.address != "" &&
        this.edit.pin_code != "" &&
        this.edit.city != "" &&
        this.edit.state != "" &&
        this.edit.phpne != "" &&
        this.name_error == "" &&
        this.address_error == "" &&
        this.pin_code_error == "" &&
        this.city_error == "" &&
        this.state_error == "" &&
        this.phone_error == ""
      ) {
        this.$root.error_message = "";
        this.$root.success_message = "";
        this.$root.page_loader = true;
        var form = new FormData();
        form.append("customer_id", this.$root.customer_id);
        form.append("customer_session", this.$root.customer_session);
        form.append("address_id", this.edit.address_id);
        form.append("full_name", this.edit.name);
        form.append("street_address", this.edit.address);
        form.append("pin_code", this.edit.pin_code);
        form.append("area", this.edit.areaselect);
        form.append("flat_no", this.edit.flat);
        form.append("landmark", this.edit.landmark);
        form.append("city", this.edit.city);
        form.append("state_name", this.edit.state);
        form.append("phone", this.edit.phone);
        if (this.otherAddressType != "" && this.edit.address_type == "others") {
          form.append("address_type", this.otherAddressType);
        } else {
          form.append("address_type", this.edit.address_type);
        }

        form.append("default", this.edit.default);
        form.append("lat", this.markers[0].position.lat);
        form.append("lng", this.markers[0].position.lng);
        axios
          .post(this.$root.cart_api + "/customer/edit-address", form)
          .then((response) => {
            if (response.data.success === true) {
              this.isMap = true;
              this.$root.address = response.data.data.address;
              this.$root.error_message = "";
              this.$root.page_loader = false;
              this.address_popup = true;
              this.$toast.success(response.data.message, {
                position: "top",
                duration: 4000,
              });
            } else {
              this.$root.success_message = "";
              this.$root.page_loader = false;
              this.$toast.error(response.data.message, {
                position: "top",
                duration: 4000,
              });
              if (response.data.customer_session_status == false) {
                this.$cookies.set(
                  window.location.hostname.substring(10, 4) + "_customer",
                  "",
                  "1y"
                );
                this.$cookies.set(
                  window.location.hostname.substring(10, 4) + "_cus_sess",
                  "",
                  "1y"
                );
                this.$root.customer_id = "";
                this.$root.customer_session = "";
                this.$cookies.set(
                  window.location.hostname.substring(10, 4) + "_cart",
                  "",
                  "1y"
                );
                this.$cookies.set(
                  window.location.hostname.substring(10, 4) + "_ct_sess",
                  "",
                  "1y"
                );
                this.$root.cart_id = "";
                this.$root.cart_session = "";
                this.$root.cart_product = [];
                this.$router.push("/cart");
              }
            }
          })
          .catch((error) => {
            this.$root.page_loader = false;
            if (error.message === "Network Error") {
              this.$toast.error(
                "Oops there seems to be some Network issue, please try again.",
                {
                  position: "top",
                  duration: 4000,
                }
              );
            }
            window.scrollTo(0, 0);
          });
      }
    },
    mark(event) {
      let lat = event.latLng.lat();

      let lng = event.latLng.lng();

      this.markers[0].position.lat = lat;
      this.markers[0].position.lng = lng;
      this.$root.location.lat = lat;
      this.$root.location.long = lng;
      this.reverseGeocodeText();
    },
    // addLocation(){
    // 	 const locationButton = document.createElement("button");
    // 	locationButton.textContent = "Pan to Current Location";
    // 	  locationButton.classList.add("custom-map-control-button");
    // 	   controlDiv.appendChild(locationButton)
    // 	// map.controls[google.maps.ControlPosition.TOP_CENTER].push(locationButton);

    // },
    reverseGeocode() {
      this.address_popup = true;
      this.user.phone = this.mobile_number;

      const that = this;
      let add = this.user.address,
        city = this.user.city,
        pin = this.user.pin_code;
      if (this.isEditAddress) {
        add = this.edit.address;
        city = this.edit.city;
        pin = this.edit.pin_code;
      }
      axios
        .get(
          `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
            `${add}`
          )},${city}, ${pin},
																&key=AIzaSyABzA9XnM_g51esLxbDQdAdZAjtz3wjIMc`
        )
        .then((response) => {
          // console.log(response.data.results[0].geometry.location.lng);
          this.isMap = false;
          if (response.data.status == "OK") {
            this.$root.location.lat =
              response.data.results[0].geometry.location.lat;
            this.$root.location.long =
              response.data.results[0].geometry.location.lng;
            this.markers[0].position.lat =
              response.data.results[0].geometry.location.lat;
            this.markers[0].position.lng =
              response.data.results[0].geometry.location.lng;
            this.center = {
              lat: response.data.results[0].geometry.location.lat,
              lng: response.data.results[0].geometry.location.lng,
            };
          } else {
            this.$toast.warning(
              "Unable to detect exact location of your address. please pin your location on map",
              {
                position: "top-right",
                duration: 4000,
              }
            );
          }
          // this.cityName =
          // 	response.data.results[0].address_components[1].short_name;
          // 	this.$root.cityName = response.data.results[0].formatted_address
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => (this.loading = false));

      // this.addLocation()
    },
    // receives a place object via the autocomplete component
    // setPlace(place) {
    // 	console.log(place);
    // 	this.$root.locationPlaceId = place.place_id;
    // 	this.$cookies.set(
    // 		window.location.hostname.substring(10, 4) + "_location_placeId",
    // 		this.$root.locationPlaceId,
    // 		"1y"
    // 	);
    // 	this.$root.location.lat = place.geometry.location.lat();
    // 	this.$root.location.long = place.geometry.location.lng();
    // 	this.$root.isLocation = true;

    // 	this.$cookies.set(
    // 		window.location.hostname.substring(10, 4) + "_location_lat",
    // 		this.$root.location.lat,
    // 		"1y"
    // 	);
    // 	this.$cookies.set(
    // 		window.location.hostname.substring(10, 4) + "_location_long",
    // 		this.$root.location.long,
    // 		"1y"
    // 	);
    // 	this.currentPlace = place;
    // },
    // addMarker() {
    // 	if (this.currentPlace) {
    // 		const marker = {
    // 			lat: this.currentPlace.geometry.location.lat(),
    // 			lng: this.currentPlace.geometry.location.lng(),
    // 		};
    // 		this.markers.push({ position: marker });
    // 		this.places.push(this.currentPlace);
    // 		this.center = marker;
    // 		this.currentPlace = null;
    // 	}
    // },
    // code is unused
    // findAvailableSlot() {
    // 	let timeslots = this.timeSlots;

    // 	let that = this;

    // 	if (this.firstAvailableSlot.time_slot == undefined) {
    // 		Object.keys(timeslots).forEach(function (key) {
    // 		if(!that.firstAvailableSlot.time_slot) {
    // 			timeslots[key].find((e) => {

    // 				if (e.is_available == true) {
    // 					that.firstAvailableSlot = e;
    // 					const index = timeslots[key].indexOf(e);

    // 					that.firstAvailableSlotIndex = index;
    // 					if(that.isExpressDelivery) {
    // 						that.selectTimeSlot(e, index,true);
    // 					} else {
    // 						that.selectTimeSlot(e, index);

    // 					}

    // 					return e;
    // 				}
    // 			});

    // 		}

    // 		});
    // 	}
    // 	// this.timeSlot
    // },
    // end here
    schedule() {
      this.scheduleSelectOption = !this.scheduleSelectOption;
      // console.log(Object.keys(this.selectedSlot).length);
      if (this.scheduleSelectOption) {
        this.selectedSlot = { date: null };
      }
    },
    changePageType(type) {
      // console.log("type", type)
      // alert("type")

      // if(this.page_type=='delivery'){

      // console.log("changePageType", this.selectedSlot.length)
      // if(this.selectedSlot.length == undefined){
      // 	return
      // 	}else{

      // 	}

      // }
      // this.back_page_type = this.$route.query.page_type;
      this.page_type = type;
      this.$router.push({ query: { page_type: type } });
      this.get_account();
      // this.$router.push({query:type})
    },
    getTimeSlot(date = null, storeArg = null) {
      let newData = [...this.cartWiseSlots];
      newData.forEach((store) => {
        if (store.store_id == storeArg) {
          store.store_data.forEach((data) => {
            data.selectedDate = false;
            if (data.date == date) {
              data.selectedDate = true;
            }
          });
        }
      });
      this.cartWiseSlots = newData;
      //this.timeSlot = storeSlot[date];
    },
    scheduleDelivery(storeArg = null, express = false) {
      let newData = [...this.cartWiseSlots];
      newData.forEach((store) => {
        // store.isSchedule = false;
        if (store.store_id == storeArg) {
          if (express) {
            store.isSchedule = false;
          } else {
            store.isSchedule = !store.isSchedule;
          }
        }
      });
      this.cartWiseSlots = newData;
      if (express == false) {
        let index = this.selectedSlots.findIndex((x) => x.store_id == storeArg);
        if (index != null || index != undefined) {
          let slots = [...this.selectedSlots];
          if (slots[index].slot.date) {
            slots.splice(index, 1);
            this.selectedSlots = slots;
          }
        }
      }
      //this.timeSlot = storeSlot[date];
    },
    apply_coupon_typed() {
      // console.log("called");
      Object.values(this.coupon_list).map((item) => {
        // console.log(item);
        let store = item.filter((element) => {
          return (
            element.coupon_code.toLowerCase() ==
            this.applied_coupon.toLowerCase()
          );
        });
        if (store.length > 0) {
          this.apply_coupon(store[0]);
        } else {
          this.$root.error_message = "No Such Coupon Available";
        }
      });
    },
    toggleCoupon() {
      // console.log("called");
      this.coupon_popup = !this.coupon_popup;
    },
    toggleViewdetails() {
      this.viewDetailspopup = !this.viewDetailspopup;
    },
    getCouponList() {
      //console.log(this.$root.cart_product);
      let storeList = [];
      this.$root.cart_product.forEach((product) => {
        // console.log("product");
        if (storeList.includes(product.store_id) === false) {
          storeList.push(product.store_id);
        }
      });
      storeList = storeList.join("-");
      // console.log("called from ");

      // let form = new FormData()
      // form.append('type', 'coupons');
      // form.append('s',storeList);
      axios
        .get(this.$root.api_url + "/pim/promotions/listapi.php", {
          params: {
            type: "coupons",
            s: storeList,
          },
        })
        .then((res) => {
          this.coupon_list = res.data;
        });
    },
    // formatPrice(value, precision = false) {
    // 	let val;

    // 	if (precision) val = (value / 1).toFixed(2).replace(",", ",");
    // 	else val = (value / 1).toFixed(0).replace(",", ",");

    // 	return `<span>&#8377;</span> ${val
    // 		.toString()
    // 		.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    // 		.replace(".00", "<small>.00</small>")} `;
    // },
    useCredits() {
     
      if (
        !this.useStoreCredit &&
        this.$root.storeCredit > this.$root.cart_total
      ) {
        this.payment_method = "credits";
        this.useStoreCredit = !this.useStoreCredit;
        this.netPayable=0
      } else {
         this.netPayable=this.$root.cart_total-this.$root.storeCredit
        this.payment_method = "";
        this.useStoreCredit = !this.useStoreCredit;
      }
     
      console.log("payment methods", this.payment_method);
      console.log("storecredit", this.useStoreCredit);
    },
    selectTimeSlot(value, date = null, express = false) {
      // console.log(value);
      // if(this.isExpressDelivery && express) {
      // 	this.selectedSlot = this.expressSlot ? this.expressSlot : {date: null}
      // 	this.isExpress = 1
      // } else {
      // 	this.isExpress = 0
      // 	this.selectedSlot = { date: this.selectedDate, ...value };

      // }
      let present = this.selectedSlots.some(
        (date) => date.store_id === value.store_id
      );
      if (present) {
        let index = this.selectedSlots.findIndex(
          (x) => x.store_id === value.store_id
        );
        if (this.selectedSlots[index].slot.date) {
          this.selectedSlots.splice(index, 1);
        } else {
          this.selectedSlots.splice(index, 1);
          this.selectedSlots.push(value);
        }
      } else {
        this.selectedSlots.push(value);
      }
      this.$cookies.set(
        window.location.hostname.substring(10, 4) + "_time_slot_id",
        value.time_slot_id,
        "1y"
      );
      this.$cookies.set(
        window.location.hostname.substring(10, 4) + "_date",
        this.selectedDate,
        "1y"
      );
      this.$cookies.set(
        window.location.hostname.substring(10, 4) + "_time",
        value.time_slot,
        "1y"
      );
      // this.page_type = 'payment'
    },
    chooseOtpRequiredForDelivery(){
     
      var form = new FormData();
      form.append("order_quotes", JSON.stringify(this.otpRequired));
      axios
        .post(this.$root.cart_api + "/otp/otp-required", form, {
          headers: {
            Accept: "application/json",
          },
        })
        .then((res) => {
      
          if (res.data.success == true) {
           console.log(res)
          } else {
            this.$toast.error(res.data.message, {
              position: "top",
              duration: 4000,
            });
          }
        })
        .catch((err) => {
       
        });
    },
    saveSlots() {

      this.chooseOtpRequiredForDelivery()

      let slots = {},
        exp = 0;

      if (this.isSelectedExpressDelivery) {
        exp = 1;
        let slot = {
          slot_id: this.expressSlot.slot_id,
          time_slot_id: this.expressSlot.time_slot_id,
          time_slot_string: this.expressSlot.time_slot,
          time_slot_date: this.expressSlot.date,
        };
        slots["express"] = slot;
      } else {
        this.selectedSlots.forEach((store) => {
          let slot = {
            slot_id: store.slot.slot_id,
            time_slot_id: store.slot.time_slot_id,
            time_slot_string: store.slot.time_slot,
            time_slot_date: store.date,
          };
          slots[store.store_id] = slot;
        });
      }
          if (this.isPrescription == true) {
     
              let count=document.getElementsByClassName('uploadPrescribe');
              this.totalpres=count.length
               
              if(this.totalpres==this.selectedFile.length){
                  for(let i=0;i<this.selectedFile.length;i++){
                    if(this.selectedFile[i].callback==false &&  this.selectedFile[i].images==null){
                      this.$toast.error("Please Upload All Prescriptions Or Request Callback", {
                      position: "top",
                      duration: 4000,
                      });
                       return;
                    }
                    else{
                      this.uploadImage(this.selectedFile[i])
                    }
                  }
                  
              }
              else{
                  this.$toast.error("Please Upload All Prescriptions Or Request Callback", {
                  position: "top",
                  duration: 4000,
                  });
                return;
              }
          }
      var form = new FormData();
      form.append("pcart", this.$root.pcart);
      form.append("customer_id", this.$root.customer_id);
      form.append("customer_session", this.$root.customer_session);
      form.append("exp", exp);
      form.append("slots", JSON.stringify(slots));

      axios
        .post(this.$root.cart_api + "/save-slots", form, {
          headers: {
            Accept: "application/json",
          },
        })
        .then((res) => {
          // this.back_page_type = "address";
          if (res.data.success == true) {
            console.log(res.data);
            this.back_page_type = "delivery";
            this.changePageType("payment");
          } else {
            this.$toast.error(res.data.message, {
              position: "top",
              duration: 4000,
            });
          }
        })
        .catch((err) => {
          // this.$toast.error('something went wrong.', {
          // 		position: "top",
          // 		duration: 4000,
          // 	});
        });
    },
    getCartWiseSlots() {
      var form = new FormData();
      form.append("pcart", this.$root.pcart);
      axios
        .post(this.$root.cart_api + "/slots", form)
        .then((res) => {
          if (res.data.success == true) {
            this.isExpressDelivery = res.data.data.express;
            this.expressSlot = res.data.data.express_slot;
            this.cartWiseSlots = res.data.data.slots;
            //let i_schedule = 0;
            this.cartWiseSlots.forEach((store) => {
              let fill = 0;
              store.isSchedule = false;
              store.store_data.forEach((data) => {
                if (fill == 0) {
                  data.selectedDate = true;
                } else {
                  data.selectedDate = false;
                }

                fill = fill + 1;
              });
            });
            for (let i = 0; i < this.cartWiseSlots.length; i++) {
              if (this.cartWiseSlots[i].prescription_required == true) {
                this.isPrescription = true;
                return;
              } else {
                this.isPrescription = false;
              }
            }
          } else {
            this.$toast.error(res.data.message, {
              position: "top",
              duration: 4000,
            });
          }
        })
        .catch((err) => {
          // this.$toast.error('something went wrong.', {
          // 		position: "top",
          // 		duration: 4000,
          // 	});
        });
    },
    razorpay_function() {
      const options = {
        key: this.razorpay_form.fkey,
        amount: this.razorpay_form.amount,
        name: this.razorpay_form.name,
        description: this.razorpay_form.description,
        image: this.razorpay_form.image,
        payment_capture: 1,
        order_id: this.razorpay_form.id,

        handler: (response) => {
          this.$root.page_loader = true;

          var form = new FormData();
          form.append(
            "pcart",
            this.$cookies.get(
              window.location.hostname.substring(10, 4) + "_cart"
            )
          );

          form.append(
            "cart_session",
            this.$cookies.get(
              window.location.hostname.substring(10, 4) + "_carts"
            )
          );
          form.append("razor_id", response.razorpay_payment_id);

          // form.append("payment_method", this.payment_method); $cookies.set(window.location.hostname.substring(10, 4) + '_time_slot_id', value.id, "1y")

          form.append(
            "time_slot_id",
            this.$cookies.get(
              window.location.hostname.substring(10, 4) + "_time_slot_id"
            )
          );
          form.append(
            "date",
            this.$cookies.get(
              window.location.hostname.substring(10, 4) + "_date"
            )
          );
          // console.log(
          // 	this.$cookies.get(window.location.hostname.substring(10, 4) + "_cv")
          // );
          if (
            this.$cookies.get(
              window.location.hostname.substring(10, 4) + "_cv"
            ) != "null"
          ) {
            form.append(
              "cv",
              this.$cookies.get(
                window.location.hostname.substring(10, 4) + "_cv"
              )
            );
          }

          form.append(
            "time",
            this.$cookies.get(
              window.location.hostname.substring(10, 4) + "_time"
            )
          );
          // form.append("time_slot_id" ,this.selectedSlot.time_slot_id)
          // form.append("date" ,this.selectedSlot.date)
          // form.append("time" ,this.selectedSlot.time_slot)

          var razorpay_order_api = "";
          razorpay_order_api = `${this.$root.cart_api}/order/razorpay-order`;

          fetch(razorpay_order_api, {
            method: "post",
            body: form,
          })
            .then((response) => response.json())
            .then((data) => {
              if (data.success == true) {
                this.$cookies.remove(
                  window.location.hostname.substring(10, 4) + "_cv"
                );
                location.replace("http://" + location.host + "/thankyou.html");
              } else {
                this.$root.page_loader = false;
                this.isPlaceOrder = false;
                // console.log(response.message);
                // document.getElementById("r_page_loader").style.display = "none";
              }
            })
            .catch((error) => {
              this.$root.page_loader = false;
              // console.log(error.message);
              // document.getElementById("r_page_loader").style.display = "none";
            });
        },
        prefill: {
          name: this.razorpay_form.prefill.name,
          email: this.razorpay_form.prefill.email,
          contact: this.razorpay_form.prefill.contact,
        },
        notes: {
          order_id: this.razorpay_form.notes.id,
        },
        theme: {
          color: this.razorpay_form.theme.color,
        },
      };
      const rzp = new Razorpay(options);
      rzp.open();
      this.loader = false;
    },
    address_type_change(event) {
      this.user.address_type = event.target.value;
      this.address_type_error = "";
    },
    edit_address_type_change(event) {
      this.edit.address_type = event.target.value;
    },
    place_order_gift(value) {
      this.$root.page_loader = true;
      if (value == "cod" || value == "gift") {
        this.payment_method = "cod";
        this.place_order();
      }
      if (value == "payu") {
        this.payment_method = "payu";
        this.place_order();
      }
    },
    apply_gift_card(e) {
      e.preventDefault();
      this.$root.page_loader = true;
      var form = new FormData();
      form.append("pcart", this.$root.pcart);
      form.append("cart_session", this.$root.cart_session);
      form.append("voucher", this.gift_card);
      this.$root.error_message = "";
      this.$root.success_message = "";
      this.gift_e_m = "";
      this.gift_s_m = "";
      axios
        .post(this.$root.cart_api + "/order/apply-giftcard", form)
        .then((response) => {
          if (response.data.success === true) {
            this.$root.page_loader = false;
            this.gift_s_m = response.data.message;
            this.gift_amount = response.data.data.gift_amount;
            this.net_amount = response.data.data.net_amount;
            this.cod_charges = response.data.data.cod_charge;
            this.shipping_charges = response.data.data.shipping_charge;
            this.apply_gift_card_code = response.data.data.voucher;
            this.$root.cart_product = response.data.data.products;
            this.$root.cart_total = response.data.data.grand_total;
            this.$root.cart_subtotal = response.data.data.order_subtotal;
          } else {
            this.$root.page_loader = false;
            this.gift_s_m = "";
            this.gift_e_m = response.data.message;
            if (response.data.cart_session_status == false) {
              this.$cookies.set(
                window.location.hostname.substring(10, 4) + "_customer",
                "",
                "1y"
              );
              this.$cookies.set(
                window.location.hostname.substring(10, 4) + "_cs",
                "",
                "1y"
              );
              this.$root.customer_id = "";
              this.$root.customer_session = "";
              this.$cookies.set(
                window.location.hostname.substring(10, 4) + "_cart",
                "",
                "1y"
              );
              this.$cookies.set(
                window.location.hostname.substring(10, 4) + "_carts",
                "",
                "1y"
              );
              this.$root.pcart = "";
              this.$root.cart_session = "";
              this.$root.cart_product = [];
              this.$router.push("/cart.html");
            }
          }
        })
        .catch((error) => {
          this.$root.page_loader = false;
          if (error.message === "Network Error") {
            this.$root.error_message =
              "Oops there seems to be some Network issue, please try again.";
          }
          window.scrollTo(0, 0);
        });
    },

    apply_coupon(coupon) {
      this.coupon_process = true;
      this.couponProcessing.push(coupon);
      // console.log(e);
      // e.preventDefault();
      var form = new FormData();
      form.append("pcart", this.$root.pcart);
      form.append("cart_session", this.$root.cart_session);
      form.append("coupon", coupon.coupon_code);
      form.append("store", coupon.store);
      this.$root.error_message = "";
      this.$root.success_message = "";
      // this.coupon_e_m = "";
      // this.coupon_s_m = "";

      axios
        .post(this.$root.cart_api + "/cart/assign-coupon", form)
        .then((response) => {
          if (response.data.success === true) {
            // console.log(response.data.discountAmount);
            this.applied_coupon_arr.push(coupon);
            this.coupon_process = false;
            this.coupon_popup = true;
            this.couponProcessing = [];
            this.applied_coupon = "";
            this.$root.page_loader = false;
            this.$root.shipping_charge = response.data.shippingCharge;
            this.$root.cart_total = response.data.grandTotal;
            this.$root.cart_subtotal = response.data.subTotal;
            this.$root.cart_netAmount = response.data.netAmount;
            this.$root.discount_amount = response.data.discountAmount;
            this.netPayable=this.$root.cart_total-this.$root.storeCredit;
            if (this.$root.pcart === null) {
              this.$root.pcart = response.data.pcart;
            }
            if (response.data.data.length > 0) {
              let ProductsArray = [];
              this.applied_coupon_arr = [];
              // Sorting Products array according to SKU

              response.data.data.forEach((cart) => {
                ProductsArray = [...ProductsArray, ...cart.products];
                if (cart.is_grocery) {
                  this.isGrocery = true;
                }
                if (cart.cookieDelete === 1) {
                  this.$cookies.set(
                    window.location.hostname.substring(10, 4) + "_cart",
                    ""
                  );
                  this.$root.pcart = "";
                }
                if (
                  cart.discount_code != "" &&
                  cart.discount_code != null &&
                  cart.discount_by != "platform"
                ) {
                  let coupon = {
                    store: cart.store,
                    coupon_code: cart.discount_code,
                  };
                  this.applied_coupon_arr.push(coupon);
                }
                if (cart.discount_by == "platform") {
                  let coupon = {
                    store: 0,
                    coupon_code: cart.discount_code,
                  };
                  if (this.applied_coupon_arr.length == 0) {
                    this.applied_coupon_arr.push(coupon);
                  }
                }
              });

              this.$root.cart_product = ProductsArray;
            } else {
              this.$root.cart_product = [];
              this.$root.shipping_charge = response.data.shippingCharge;
              this.$root.cart_total = response.data.grandTotal;
              this.$root.cart_subtotal = response.data.subTotal;
              this.$root.cart_netAmount = response.data.netAmount;
              this.$root.discount_amount = response.data.discountAmount;

              //  this.$store.dispatch('getCart', response.data.data.products)
            }

            this.$toast.success(response.data.message, {
              position: "top",
              duration: 4000,
            });
            this.$root.error_message = "";
          } else {
            this.$toast.error(response.data.message, {
              position: "top",
              duration: 4000,
            });
            this.$root.page_loader = false;
            // this.coupon_s_m = "";
            // this.coupon_e_m = response.data.message;
            if (response.data.cart_session_status == false) {
              this.$cookies.set(
                window.location.hostname.substring(10, 4) + "_customer",
                "",
                "1y"
              );
              this.$cookies.set(
                window.location.hostname.substring(10, 4) + "_cs",
                "",
                "1y"
              );
              this.$root.customer_id = "";
              this.$root.customer_session = "";
              this.$cookies.set(
                window.location.hostname.substring(10, 4) + "_cart",
                "",
                "1y"
              );
              this.$cookies.set(
                window.location.hostname.substring(10, 4) + "_carts",
                "",
                "1y"
              );
              // this.$root.pcart = '';
              this.$root.cart_session = "";
              this.$root.cart_product = [];
              this.$router.push("/cart.html");
            }
          }
        })
        .catch((error) => {
          this.$root.page_loader = false;

          if (error.message === "Network Error") {
            this.$toast.error(
              "Oops there seems to be some Network issue, please try again.",
              {
                position: "top",
                duration: 4000,
              }
            );
            // this.$root.error_message =
            // 	"Oops there seems to be some Network issue, please try again.";
          }
          window.scrollTo(0, 0);
        });
    },
    remove_coupon: function (rcoupon) {
      this.$root.page_loader = true;
      var form = new FormData();
      form.append("pcart", this.$root.pcart);
      form.append("store", rcoupon.store);
      form.append("coupon_code", rcoupon.coupon_code);
      this.$root.error_message = "";
      this.$root.success_message = "";

      axios
        .post(this.$root.cart_api + "/cart/remove-coupon", form)
        .then((response) => {
          if (response.data.success === true) {
            this.$root.page_loader = false;
            this.$root.error_message = "";
            this.$root.shipping_charge = response.data.shippingCharge;
            this.$root.cart_total = response.data.grandTotal;
            this.$root.cart_subtotal = response.data.subTotal;
            this.$root.cart_netAmount = response.data.netAmount;
            this.$root.discount_amount = response.data.discountAmount;
            this.netPayable=this.$root.cart_total-this.$root.storeCredit;
            if (this.$root.pcart === null) {
              this.$root.pcart = response.data.pcart;
            }
            this.$toast.warning("Coupon removed successfully", {
              position: "top",
              duration: 4000,
            });
            if (response.data.data.length > 0) {
              let ProductsArray = [];
              this.applied_coupon_arr = [];
              // Sorting Products array according to SKU

              response.data.data.forEach((cart) => {
                ProductsArray = [...ProductsArray, ...cart.products];
                if (cart.is_grocery) {
                  this.isGrocery = true;
                }
                if (cart.cookieDelete === 1) {
                  this.$cookies.set(
                    window.location.hostname.substring(10, 4) + "_cart",
                    ""
                  );
                  this.$root.pcart = "";
                }
                if (
                  cart.discount_code != "" &&
                  cart.discount_code != null &&
                  cart.discount_by != "platform"
                ) {
                  let coupon = {
                    store: cart.store,
                    coupon_code: cart.discount_code,
                  };
                  this.applied_coupon_arr.push(coupon);
                }
                if (cart.discount_by == "platform") {
                  let coupon = {
                    store: 0,
                    coupon_code: cart.discount_code,
                  };
                  if (this.applied_coupon_arr.length == 0) {
                    this.applied_coupon_arr.push(coupon);
                  }
                }
              });

              this.$root.cart_product = ProductsArray;
            } else {
              this.$root.cart_product = [];
              this.$root.shipping_charge = response.data.shippingCharge;
              this.$root.cart_total = response.data.grandTotal;
              this.$root.cart_subtotal = response.data.subTotal;
              this.$root.cart_netAmount = response.data.netAmount;
              this.$root.discount_amount = response.data.discountAmount;

              //  this.$store.dispatch('getCart', response.data.data.products)
            }

            // this.applied_coupon_arr = this.applied_coupon_arr.filter((x,i) => {
            // 	if((x.coupon_code == rcoupon.coupon_code) && (x.store == rcoupon.store)){}
            // 	else { return x }
            // })
          } else {
            this.$root.page_loader = false;
            this.$root.success_message = "";
            this.coupon_e_m = response.data.message;
            if (response.data.cart_session_status == false) {
              this.$cookies.set(
                window.location.hostname.substring(10, 4) + "_customer",
                "",
                "1y"
              );
              this.$cookies.set(
                window.location.hostname.substring(10, 4) + "_cs",
                "",
                "1y"
              );
              this.$root.customer_id = "";
              this.$root.customer_session = "";
              this.$cookies.set(
                window.location.hostname.substring(10, 4) + "_cart",
                "",
                "1y"
              );
              this.$cookies.set(
                window.location.hostname.substring(10, 4) + "_carts",
                "",
                "1y"
              );
              // this.$root.pcart = '';
              this.$root.cart_session = "";
              this.$root.cart_product = [];
              this.$router.push("/cart.html");
            }
          }
        })
        .catch((error) => {
          this.$root.page_loader = false;
          if (error.message === "Network Error") {
            this.$root.error_message =
              "Oops there seems to be some Network issue, please try again.";
          }
          window.scrollTo(0, 0);
        });
    },

    show_all_address() {
      this.address_show_hide = true;
      this.address_show_hide_length = this.$root.address.length;
    },
    hide_all_address() {
      this.address_show_hide = false;
      this.address_show_hide_length = 1;
      window.scrollTo(0, 0);
    },
    section_back() {
      this.page_type = "address";
      window.scrollTo(0, 0);
    },

    countDownTimer() {
      if (this.resend_otp_time > 0) {
        setTimeout(() => {
          this.resend_otp_time -= 1;
          this.countDownTimer();
        }, 1000);
      }
      if (this.resend_otp_time == 0) {
        this.resend_otp_time = 60;
      }
    },
    resend_otp() {
      this.send_otp_btn = false;
      setTimeout(() => {
        this.$refs.otpCheckout.focus();
      }, 0);
      this.$root.error_message = "";
      this.$root.success_message = "";
      this.otp_number = "";
      this.resend_otp_time = 60;
      this.countDownTimer();
      var form = new FormData();
      form.append("phone", this.mobile_number);
      let config = { headers: { "Content-Type": "multipart/form-data" } };
      axios
        .post(this.$root.cart_api + "/customer/send-otp", form, config)
        .then((response) => {
          if (response.data.success === true) {
            this.$root.success_message = response.data.message;
            this.$root.error_message = "";
          } else {
            this.$root.error_message = response.data.message;
            this.$root.success_message = "";
            window.scrollTo(0, 0);
          }
        })
        .catch((error) => {
          this.$root.page_loader = false;
          if (error.message === "Network Error") {
            this.$root.error_message =
              "Oops there seems to be some Network issue, please try again.";
          }
          window.scrollTo(0, 0);
        });
    },
    customer_select_new_address: function () {
      this.page_type = "new_address_page";
      this.user.phone = this.mobile_number;
      window.scrollTo(0, 0);
    },
    user_email() {
      // console.log("called");
      var email =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (this.user.email.match(email)) {
        this.email_error = "";
      } else {
        this.email_error = "Please enter valid Email";
      }
    },
    user_name: function () {
      var name = /^(?!\s*$).+/;
      if (this.user.name.match(name)) {
        this.name_error = "";
      } else {
        this.name_error = "Please enter valid Name";
      }
    },
    user_city: function () {
      var city = /^(?!\s*$).+/;
      if (this.user.city.match(city)) {
        this.city_error = "";
      } else {
        this.city_error = "Please enter valid City";
      }
    },
    user_address: function () {
      var address = /^(?!\s*$).+/;
      if (this.user.address.match(address)) {
        this.address_error = "";
      } else {
        this.address_error = "Please enter valid Address";
      }
    },

    get_account: async function () {

      
      if (this.$root.customer_id != null && this.$root.customer_id != "") {
        this.$root.error_message = "";
        this.$root.success_message = "";
        var form = new FormData();
        form.append("customer_id", this.$root.customer_id);
        form.append("customer_session", this.$root.customer_session);
        form.append("store", this.$root.store);
        let response = await axios
          .post(this.$root.cart_api + "/customer/account-details", form)
          // .then((response) => {
            if (response.data.success === true) {
              console.log("res of get acc")
              this.mobile_number = response.data.data.phone;
              this.$root.wishListProducts = response.data.data.wishlistCount;
              // console.log("called add");
              // console.log(response.data.data.address);
              this.$root.address = [...response.data.data.address];
              this.$root.storeCredit = response.data.data.storeCredit;
              this.isParentRendered = true;

              // console.log(this.$root.address);
            } else {
              this.isParentRendered = true;
              if (
                response.data.customer_session_status == false ||
                response.data.cart_session_status == false
              ) {
                this.$cookies.set(
                  window.location.hostname.substring(10, 4) + "_customer",
                  "",
                  "1y"
                );
                this.$cookies.set(
                  window.location.hostname.substring(10, 4) + "_cs",
                  "",
                  "1y"
                );
                // this.$root.customer_id = '';
                this.$root.customer_session = "";
                this.$cookies.set(
                  window.location.hostname.substring(10, 4) + "_cart",
                  "",
                  "1y"
                );
                this.$cookies.set(
                  window.location.hostname.substring(10, 4) + "_carts",
                  "",
                  "1y"
                );
                // this.$root.pcart = '';
                this.$root.cart_session = "";
                this.$root.cart_product = [];
              }
            }
          this.accountLoader = false
          // });
      }
    },
    checkEditAddress() {
      if (
        this.edit.name != "" &&
        this.edit.address != "" &&
        this.edit.pin_code != "" &&
        this.edit.city != "" &&
        this.edit.state != "" &&
        this.edit.phpne != "" &&
        this.name_error == "" &&
        this.address_error == "" &&
        this.pin_code_error == "" &&
        this.city_error == "" &&
        this.state_error == "" &&
        this.phone_error == ""
      ) {
        this.reverseGeocode();
      }
    },
    checkAddAddress() {
      this.user.phone = this.mobile_number;
      if (
        this.user.address_type != "" &&
        this.user.name != "" &&
        this.user.address != "" &&
        this.user.pin_code != "" &&
        this.user.city != "" &&
        this.user.state != "" &&
        this.user.phone != "" &&
        this.user.email != "" &&
        this.name_error == "" &&
        this.address_error == "" &&
        this.pin_code_error == "" &&
        this.city_error == "" &&
        this.state_error == "" &&
        this.email_error == "" &&
        this.phone_error == "" &&
        this.address_type_error == ""
      ) {
        this.reverseGeocode();
      } else {
        this.user_name();
        this.user_email();
        this.user_phone();
        this.user_pin_code();
        this.user_address();
        this.user_city();
        if (this.user.address_type == "") {
          this.address_type_error = "Please select an address type";
        } else {
          this.address_type_error = "";
        }
      }
    },
    new_address: function () {
      if (
        this.user.address_type != "" &&
        this.user.name != "" &&
        this.user.address != "" &&
        this.user.pin_code != "" &&
        this.user.city != "" &&
        this.user.state != "" &&
        this.user.phone != "" &&
        this.user.email != "" &&
        this.name_error == "" &&
        this.address_error == "" &&
        this.pin_code_error == "" &&
        this.city_error == "" &&
        this.state_error == "" &&
        this.email_error == "" &&
        this.phone_error == "" &&
        this.address_type_error == ""
      ) {
        this.$root.error_message = "";
        this.$root.success_message = "";
        this.$root.page_loader = true;
        var form = new FormData();
        form.append("pcart", this.$root.pcart);
        form.append("customer_id", this.$root.customer_id);
        form.append("customer_session", this.$root.customer_session);
        form.append("full_name", this.user.name);
        form.append("street_address", this.user.address);
        form.append("pin_code", this.user.pin_code);
        form.append("city", this.user.city);
        form.append("flat_no", this.user.flat);
        form.append("landmark", this.user.landmark);
        form.append("state_name", this.user.state);
        form.append("phone", this.user.phone);
        form.append("email", this.user.email);
        if (this.otherAddressType != "" && this.user.address_type == "others") {
          form.append("address_type", this.otherAddressType);
        } else {
          form.append("address_type", this.user.address_type);
        }

        form.append("lat", this.markers[0].position.lat);
        form.append("lng", this.markers[0].position.lng);
        let config = { headers: { "Content-Type": "multipart/form-data" } };
        axios
          .post(this.$root.cart_api + "/customer/add-address", form, config)
          .then((response) => {
            // console.log(response);
            if (response.data.success == true) {
              if (response.data.undeliverableStores.length === 0) {
                this.isMap = true;
                this.page_type = "delivery";
                this.$router.push({ query: { page_type: "delivery" } });
                this.$root.address = [...response.data.data[0].address];
                this.$root.address_id = response.data.data[0].maddress.id;
                this.$root.success_message = response.data.message;
                this.$root.error_message = "";
                this.$root.page_loader = false;

                this.back_page_type = "shipping";
                this.$root.page_loader = false;
                this.$root.address = [...response.data.data[0].address];
                this.$root.cart_product = response.data.data[0].products;
                this.$cookies.set(
                  window.location.hostname.substring(10, 4) + "_co_add",
                  response.data.data[0].maddress,
                  "1y"
                );
                if (response.data.data[0].customer.cod_block) {
                  if (response.data.data[0].customer.cod_block == "0") {
                    this.cus_cod_hide = true;
                  } else {
                    this.cus_cod_hide = false;
                  }
                }

                // this.$gtm.trackEvent({
                //     event: 'checkout',
                //     category: 'Ecommerce',
                //     action: 'Checkout',
                //     label: '4',
                //     ecommerce: {
                //         checkout: {
                //             'actionField': { 'step': 4, 'option': 'Address selected' },
                //             product: this.$root.gtm_product,
                //         }
                //     }
                // });
              } else {
                this.isMap = true;
                this.isDropCartItemsPopup = true;
                this.dropCartItemsStores = [];
                this.dropCartItemsStores = response.data.undeliverableStores;
              }
            } else {
              this.$root.error_message = response.data.message;
              this.$root.success_message = "";
              this.$root.page_loader = false;
              window.scrollTo(0, 0);
              if (response.data.customer_session_status == false) {
                this.$cookies.set(
                  window.location.hostname.substring(10, 4) + "_customer",
                  "",
                  "1y"
                );
                this.$cookies.set(
                  window.location.hostname.substring(10, 4) + "_cs",
                  "",
                  "1y"
                );
                this.$root.customer_id = "";
                this.$root.customer_session = "";
                this.$cookies.set(
                  window.location.hostname.substring(10, 4) + "_cart",
                  "",
                  "1y"
                );
                this.$cookies.set(
                  window.location.hostname.substring(10, 4) + "_carts",
                  "",
                  "1y"
                );
                // this.$root.pcart = '';
                this.$root.cart_session = "";
                this.$root.cart_product = [];
                this.$router.push("/cart.html");
              }
            }
          })
          .catch((error) => {
            this.$root.page_loader = false;
            if (error.message === "Network Error") {
              this.$root.error_message =
                "Oops there seems to be some Network issue, please try again.";
            }
            window.scrollTo(0, 0);
          });
      } else {
        this.user_name();
        this.user_phone();
        this.user_pin_code();
        this.user_address();
        this.user_city();
        if (this.user.address_type == "") {
          this.address_type_error = "Please select an address type";
        } else {
          this.address_type_error = "";
        }
      }
    },
    g_checkout: function () {
      if (
        this.user.address_type != "" &&
        this.user.name != "" &&
        this.user.address != "" &&
        this.user.pin_code != "" &&
        this.user.city != "" &&
        this.user.state != "" &&
        this.mobile_number != "" &&
        this.name_error == "" &&
        this.address_error == "" &&
        this.pin_code_error == "" &&
        this.city_error == "" &&
        this.state_error == "" &&
        this.email_error == "" &&
        this.mobile_error == "" &&
        this.address_type_error == ""
      ) {
        this.$root.page_loader = true;
        this.$root.error_message = "";
        this.$root.success_message = "";
        var form = new FormData();
        if (this.$root.g_customer_id != "") {
          form.append("customer_id", this.$root.g_customer_id);
        }
        form.append("pcart", this.$root.pcart);
        form.append("cart_session", this.$root.cart_session);
        form.append("full_name", this.user.name);
        form.append("street_address", this.user.address);
        form.append("pin_code", this.user.pin_code);
        form.append("city", this.user.city);
        form.append("state_name", this.user.state);
        form.append("phone", this.mobile_number);
        form.append("email", this.user.email);
        form.append("address_type", this.user.address_type);
        this.$router.push({ query: { page_type: "delivery" } });
        this.page_type = "delivery";
        let config = { headers: { "Content-Type": "multipart/form-data" } };

        //
        axios
          .post(
            "https://cart-pim.wforwomanonline.com/api/v1/customer/add-guest-address",
            form,
            config
          )
          .then((response) => {
            if (response.data.success === true) {
              this.back_page_type = this.$route.query.page_type;
              this.$root.page_loader = false;
              this.$root.address_id = response.data.data.id;
              this.$root.success_message = response.data.message;
              this.$root.error_message = "";
              this.$router.push({ query: { page_type: "delivery" } });
              this.page_type = "delivery";
              this.$cookies.set(
                window.location.hostname.substring(10, 4) + "_g_customer",
                this.user,
                "1y"
              );
              this.$cookies.set(
                window.location.hostname.substring(10, 4) + "_co_add",
                response.data.data.maddress,
                "1y"
              );
              this.last_address = response.data.data.maddress;
              this.back_page_type = "login";
              this.$root.page_loader = false;
              this.$root.cart_product = response.data.data.products;
              for (let i = 0; i < response.data.data.products.length; i++) {
                if (response.data.data.products[i].product_type == "gift") {
                  this.product_type = "gift";
                  this.payment_method = "payu";
                }
              }
              // this.$gtm.trackEvent({
              //     event: 'checkout',
              //     category: 'Ecommerce',
              //     action: 'Checkout',
              //     label: '4',
              //     ecommerce: {
              //         checkout: {
              //             'actionField': { 'step': 4, 'option': 'Address selected' },
              //             product: this.$root.gtm_product,
              //         }
              //     }
              // });
            } else {
              this.$root.error_message = response.data.message;
              this.$root.success_message = "";
              this.$root.page_loader = false;
              window.scrollTo(0, 0);
              if (response.data.cart_session_status == false) {
                this.$cookies.set(
                  window.location.hostname.substring(10, 4) + "_customer",
                  "",
                  "1y"
                );
                this.$cookies.set(
                  window.location.hostname.substring(10, 4) + "_cs",
                  "",
                  "1y"
                );
                this.$root.customer_id = "";
                this.$root.customer_session = "";
                this.$cookies.set(
                  window.location.hostname.substring(10, 4) + "_cart",
                  "",
                  "1y"
                );
                this.$cookies.set(
                  window.location.hostname.substring(10, 4) + "_carts",
                  "",
                  "1y"
                );
                // this.$root.pcart = '';
                this.$root.cart_session = "";
                this.$root.cart_product = [];
                this.$router.push("/cart.html");
              }
            }
          })
          .catch((error) => {
            this.$root.page_loader = false;
            if (error.message === "Network Error") {
              this.$root.error_message =
                "Oops there seems to be some Network issue, please try again.";
            }
            window.scrollTo(0, 0);
          });
      } else {
        this.user_name();
        this.g_mobile_no();
        this.user_address();
        this.user_city();
        this.user_pin_code();
        if (this.user.address_type == "") {
          this.address_type_error = "Please select an address type";
        } else {
          this.address_type_error = "";
        }
      }
    },
    select_address: function (index, value) {
      this.select_address_index = index;

      this.$root.address_id = value;
    },

    place_order: function () {
      console.log("1")
      this.loader = true;
      this.isPlaceOrder = true;
      // console.log('checkout add to order')
      this.$root.error_message = "";
      this.$root.success_message = "";
      this.$root.page_loader = true;
      this.$root.thankyou_status = true;
      this.$cookies.set(
        window.location.hostname.substring(10, 4) + "_thank",
        "true"
      );
      var form = new FormData();
      if (this.useStoreCredit) {
        form.append("use_store_credit", true);
      }

      form.append("pcart", this.$root.pcart);
      form.append("cart_session", this.$root.cart_session);
      form.append("payment_method", this.payment_method);
      form.append("time_slot_id", this.selectedSlot.time_slot_id);
      form.append("date", this.selectedSlot.date);
      form.append("time", this.selectedSlot.time_slot);
      form.append("is_express", this.isExpress);
      let config = { headers: { "Content-Type": "multipart/form-data" } };
      if (this.payment_method === "credits") {
        axios
          .post(this.$root.cart_api + "/order/add-order", form, config)
          .then((response) => {
            if (response.data.success === true) {
              console.log("2")
              this.$cookies.set(
                window.location.hostname.substring(10, 4) + "_cart",
                response.data.data.pcart,
                "1y"
              );
              // this.$root.pcart = response.data.data.pcart;
              this.$root.thankyou_cart = response.data.data.pcart;
              if (response.data.data.cart_session) {
                this.$cookies.set(
                  window.location.hostname.substring(10, 4) + "_carts",
                  response.data.data.cart_session,
                  "1y"
                );
                this.$root.cart_session = response.data.data.cart_session;
              }
              this.isPlaceOrder = false;
              console.log("3")
              this.$router.push("thankyou.html");
            } else {
              this.$toast.error(response.data.message, {
                position: "top-right",
                duration: 4000,
              });
              this.$root.error_message = response.data.message;
              this.$root.success_message = "";
              this.$root.page_loader = false;
              this.$root.thankyou_status = false;
              this.isPlaceOrder = false;
              this.$cookies.set(
                window.location.hostname.substring(10, 4) + "_thank",
                ""
              );
              window.scrollTo(0, 0);
              if (response.data.cart_session_status == false) {
                this.$cookies.set(
                  window.location.hostname.substring(10, 4) + "_customer",
                  "",
                  "1y"
                );
                this.$cookies.set(
                  window.location.hostname.substring(10, 4) + "_cs",
                  "",
                  "1y"
                );
                this.$root.customer_id = "";
                this.$root.customer_session = "";
                this.$cookies.set(
                  window.location.hostname.substring(10, 4) + "_cart",
                  "",
                  "1y"
                );
                this.$cookies.set(
                  window.location.hostname.substring(10, 4) + "_carts",
                  "",
                  "1y"
                );
                // this.$root.pcart = '';
                this.$root.cart_session = "";
                this.$root.cart_product = [];
                this.$router.push("/cart.html");
              }
            }
          })
          .catch((error) => {
            this.isPlaceOrder = false;
            this.$root.page_loader = false;
            this.$root.thankyou_status = false;
            this.$cookies.set(
              window.location.hostname.substring(10, 4) + "_thank",
              ""
            );
            if (error.message === "Network Error") {
              this.$toast.error(
                "Oops there seems to be some Network issue, please try again.",
                {
                  position: "top-right",
                  duration: 4000,
                }
              );

              this.$root.error_message =
                "Oops there seems to be some Network issue, please try again.";
            }
            window.scrollTo(0, 0);
          });
      }
      if (this.payment_method === "cod") {
        // console.log("called");
        // this.$gtm.trackEvent({
        //     event: 'checkout',
        //     category: 'Ecommerce',
        //     action: 'Checkout',
        //     label: '5',
        //     ecommerce: {
        //         checkout: {
        //             'actionField': { 'step': 5, 'option': 'Cash On Delivery' },
        //             product: this.$root.gtm_product,
        //         }
        //     }
        // });

        axios
          .post(this.$root.cart_api + "/order/add-order", form, config)
          .then((response) => {
            if (response.data.success === true) {
              this.isPlaceOrder = false;
              this.$cookies.set(
                window.location.hostname.substring(10, 4) + "_cart",
                response.data.data.pcart,
                "1y"
              );
              // this.$root.pcart = response.data.data.pcart;
              this.$root.thankyou_cart = response.data.data.pcart;
              if (response.data.data.cart_session) {
                this.$cookies.set(
                  window.location.hostname.substring(10, 4) + "_carts",
                  response.data.data.cart_session,
                  "1y"
                );
                this.$root.cart_session = response.data.data.cart_session;
              }
              this.$router.push("thankyou.html");
            } else {
              this.isPlaceOrder = false;
              this.$toast.error(response.data.message, {
                position: "top-right",
                duration: 4000,
              });
              this.$root.error_message = response.data.message;
              this.$root.success_message = "";
              this.$root.page_loader = false;
              this.$root.thankyou_status = false;
              this.$cookies.set(
                window.location.hostname.substring(10, 4) + "_thank",
                ""
              );
              window.scrollTo(0, 0);
              if (response.data.cart_session_status == false) {
                this.$cookies.set(
                  window.location.hostname.substring(10, 4) + "_customer",
                  "",
                  "1y"
                );
                this.$cookies.set(
                  window.location.hostname.substring(10, 4) + "_cs",
                  "",
                  "1y"
                );
                this.$root.customer_id = "";
                this.$root.customer_session = "";
                this.$cookies.set(
                  window.location.hostname.substring(10, 4) + "_cart",
                  "",
                  "1y"
                );
                this.$cookies.set(
                  window.location.hostname.substring(10, 4) + "_carts",
                  "",
                  "1y"
                );
                // this.$root.pcart = '';
                this.$root.cart_session = "";
                this.$root.cart_product = [];
                this.$router.push("/cart.html");
              }
            }
          })
          .catch((error) => {
            this.isPlaceOrder = false;
            this.$root.page_loader = false;
            this.$root.thankyou_status = false;
            this.$cookies.set(
              window.location.hostname.substring(10, 4) + "_thank",
              ""
            );
            if (error.message === "Network Error") {
              this.$toast.error(
                "Oops there seems to be some Network issue, please try again.",
                {
                  position: "top-right",
                  duration: 4000,
                }
              );
              this.$root.error_message =
                "Oops there seems to be some Network issue, please try again.";
            }
            window.scrollTo(0, 0);
          });
      }
      if (
        this.payment_method === "payu" ||
        this.payment_method === "razorpay"
      ) {
        this.$root.page_loader = true;
        // this.$gtm.trackEvent({
        //     event: 'checkout',
        //     category: 'Ecommerce',
        //     action: 'Checkout',
        //     label: '5',
        //     ecommerce: {
        //         checkout: {
        //             'actionField': { 'step': 5, 'option': 'Pay Online' },
        //             product: this.$root.gtm_product,
        //         }
        //     }
        // });
        axios
          .post(this.$root.cart_api + "/order/add-order", form, config)
          .then((response) => {
            if (response.data.success === true) {
              this.isPlaceOrder = false;
              if (response.data.data.payment_method == "payu") {
                // this.$cookies.set(window.location.hostname.substring(10, 4) + '_cart', response.data.data.pcart, "1y");
                // this.$root.pcart = response.data.data.pcart;
                this.$root.thankyou_cart = response.data.data.pcart;
                if (response.data.data.cart_session) {
                  this.$cookies.set(
                    window.location.hostname.substring(10, 4) + "_carts",
                    response.data.data.cart_session,
                    "1y"
                  );
                  this.$root.cart_session = response.data.data.cart_session;
                }
                this.payu_form.action = response.data.data.payment.payubaseurl;
                this.payu_form.key = response.data.data.payment.key;
                this.payu_form.hash = response.data.data.payment.hash;
                this.payu_form.txnid = response.data.data.payment.txnid;
                this.payu_form.amount = response.data.data.payment.amount;
                this.payu_form.email = response.data.data.payment.email;
                this.payu_form.phone = response.data.data.payment.phone;
                this.payu_form.firstname = response.data.data.payment.firstname;
                this.payu_form.productinfo =
                  response.data.data.payment.productinfo;
                this.payu_form.udf1 = response.data.data.payment.udf1;
                this.payu_form.surl = response.data.data.payment.surl;
                this.payu_form.furl = response.data.data.payment.furl;
                setTimeout(() => this.$refs.payu_click.click(), 100);
                this.isPlaceOrder = false;
              }
              if (response.data.data[0].payment_method == "razorpay") {
                this.$root.page_loader = false;
                // this.$cookies.set(window.location.hostname.substring(10, 4) + '_cart', response.data.data.pcart, "1y");
                // this.$root.pcart = response.data.data.pcart;
                this.$root.thankyou_cart = response.data.data.pcart;

                if (response.data.data.cart_session) {
                  this.$cookies.set(
                    window.location.hostname.substring(10, 4) + "_carts",
                    response.data.data.cart_session,
                    "1y"
                  );
                  this.$root.cart_session = response.data.data.cart_session;
                }

                this.razorpay_form.key = response.data.data[0].razor_key;
                this.razorpay_form.id = response.data.data[0].razor_order_id;
                this.$cookies.set(
                  window.location.hostname.substring(10, 4) + "_cv",
                  response.data.data[0].cv,
                  "1y"
                );
                this.razorpay_form.cv = response.data.data[0].cv;
                this.razorpay_form.amount =
                  response.data.data[0].grand_total * 100;
                this.razorpay_form.prefill.contact =
                  response.data.data[0].maddress.phone;
                this.razorpay_form.prefill.name =
                  response.data.data[0].maddress.full_name;
                this.razorpay_form.prefill.email =
                  response.data.data[0].customer.email;
                this.razorpay_form.notes.id =
                  response.data.data[0].order_increment_id;
                // console.log("called from razor pay");
                setTimeout(() => this.razorpay_function(), 100);
                this.isPlaceOrder = false;
              }
            } else {
              this.isPlaceOrder = false;
              this.$toast.error(response.data.message, {
                position: "top-right",
                duration: 4000,
              });
              this.$root.error_message = response.data.message;
              this.$root.success_message = "";
              this.$root.page_loader = false;
              this.$root.thankyou_status = false;
              this.$cookies.set(
                window.location.hostname.substring(10, 4) + "_thank",
                ""
              );
              window.scrollTo(0, 0);
              if (response.data.cart_session_status == false) {
                this.$cookies.set(
                  window.location.hostname.substring(10, 4) + "_customer",
                  "",
                  "1y"
                );
                this.$cookies.set(
                  window.location.hostname.substring(10, 4) + "_cs",
                  "",
                  "1y"
                );
                this.$root.customer_id = "";
                this.$root.customer_session = "";
                this.$cookies.set(
                  window.location.hostname.substring(10, 4) + "_cart",
                  "",
                  "1y"
                );
                this.$cookies.set(
                  window.location.hostname.substring(10, 4) + "_carts",
                  "",
                  "1y"
                );
                // this.$root.pcart = '';
                this.$root.cart_session = "";
                this.$root.cart_product = [];
                this.$router.push("/cart.html");
              }
            }
          })
          .catch((error) => {
            this.isPlaceOrder = false;
            this.$root.page_loader = false;
            this.$root.thankyou_status = false;
            this.$cookies.set(
              window.location.hostname.substring(10, 4) + "_thank",
              ""
            );
            if (error.message === "Network Error") {
              this.$toast.error(
                "Oops there seems to be some Network issue, please try again.",
                {
                  position: "top-right",
                  duration: 4000,
                }
              );
              this.$root.error_message =
                "Oops there seems to be some Network issue, please try again.";
            }
            window.scrollTo(0, 0);
          });
      }
    },
    assignAddress() {
      this.isLoading = true;
      if (this.$root.address_id == "") {
        this.$root.address_id = this.$root.address[0].id;
      }
      this.$root.error_message = "";
      this.$root.success_message = "";
      var form = new FormData();
      form.append("pcart", this.$root.pcart);
      form.append("cart_session", this.$root.cart_session);
      form.append("customer_id", this.$root.customer_id);
      form.append("customer_session", this.$root.customer_session);
      form.append("address_id", this.$root.address_id);
      let config = {
        headers: { "Content-Type": "multipart/form-data" },
      };
      axios
        .post(this.$root.cart_api + "/customer/assign-address", form, config)
        .then((response) => {
          if (response.data.success === true) {
            this.isLoading = false;
            if (response.data.undeliverableStores.length === 0) {
              this.$router.push({ query: { page_type: "delivery" } });
              this.page_type = "delivery";

              this.back_page_type = "address";
              this.$root.success_message = response.data.message;
              this.$root.error_message = "";
              this.$root.shipping_charge = response.data.shippingCharge;
              this.$root.cart_total = response.data.grandTotal;
              this.$root.cart_subtotal = response.data.subTotal;
              this.$root.cart_netAmount = response.data.netAmount;
              this.$root.discount_amount = response.data.discountAmount;

              if (response.data.data.length > 0) {
                let ProductsArray = [];
                // Sorting Products array according to SKU

                response.data.data.forEach((cart) => {
                  this.last_address = cart.maddress;
                  ProductsArray = [...ProductsArray, ...cart.products];
                  if (cart.cod_block == "0") {
                    this.cus_cod_hide = true;
                  } else {
                    this.cus_cod_hide = false;
                  }
                  if (cart.product_type == "gift") {
                    this.product_type = "gift";
                    this.payment_method = "payu";
                  }

                  this.$cookies.set(
                    window.location.hostname.substring(10, 4) + "_co_add",
                    cart.maddress,
                    "1y"
                  );

                  if (cart.cookieDelete === 1) {
                    this.$cookies.set(
                      window.location.hostname.substring(10, 4) + "_cart",
                      ""
                    );
                    this.$root.pcart = "";
                  }
                });

                this.$root.cart_product = ProductsArray;
              } else {
                this.$root.cart_product = [];
                this.$root.shipping_charge = response.data.shippingCharge;
                this.$root.cart_total = response.data.grandTotal;
                this.$root.cart_subtotal = response.data.subTotal;
                this.$root.cart_netAmount = response.data.netAmount;
                this.$root.discount_amount = response.data.discountAmount;
              }
              this.$root.page_loader = false;
              // this.$gtm.trackEvent({
              //     event: 'checkout',
              //     category: 'Ecommerce',
              //     action: 'Checkout',
              //     label: '4',
              //     ecommerce: {
              //         checkout: {
              //             'actionField': { 'step': 4, 'option': 'Address selected' },
              //             product: this.$root.gtm_product,
              //         }
              //     }
              // });
            } else {
              this.isDropCartItemsPopup = true;
              this.dropCartItemsStores = [];
              this.dropCartItemsStores = response.data.undeliverableStores;
            }
          } else {
            this.isLoading = false;
            this.$root.error_message = response.data.message;
            this.$root.success_message = "";
            this.$root.page_loader = false;
            window.scrollTo(0, 0);
            if (response.data.customer_session_status == false) {
              this.$cookies.set(
                window.location.hostname.substring(10, 4) + "_customer",
                "",
                "1y"
              );
              this.$cookies.set(
                window.location.hostname.substring(10, 4) + "_cs",
                "",
                "1y"
              );
              this.$root.customer_id = "";
              this.$root.customer_session = "";
              this.$cookies.set(
                window.location.hostname.substring(10, 4) + "_cart",
                "",
                "1y"
              );
              this.$cookies.set(
                window.location.hostname.substring(10, 4) + "_carts",
                "",
                "1y"
              );
              // this.$root.pcart = '';
              this.$root.cart_session = "";
              this.$root.cart_product = [];
              this.$router.push("/login.html");
            }
            if (response.data.cart_session_status == false) {
              this.$cookies.set(
                window.location.hostname.substring(10, 4) + "_customer",
                "",
                "1y"
              );
              this.$cookies.set(
                window.location.hostname.substring(10, 4) + "_cs",
                "",
                "1y"
              );
              this.$root.customer_id = "";
              this.$root.customer_session = "";
              this.$cookies.set(
                window.location.hostname.substring(10, 4) + "_cart",
                "",
                "1y"
              );
              this.$cookies.set(
                window.location.hostname.substring(10, 4) + "_carts",
                "",
                "1y"
              );
              // this.$root.pcart = '';
              this.$root.cart_session = "";
              this.$root.cart_product = [];
              this.$router.push("/cart.html");
            }
          }
        })
        .catch((error) => {
          this.$root.page_loader = false;
          this.isLoading = false;
          if (error.message === "Network Error") {
            this.$root.error_message =
              "Oops there seems to be some Network issue, please try again.";
          }
          window.scrollTo(0, 0);
        });
    },
    old_address: function () {
      this.$root.page_loader = true;
      if (this.$root.address_id == "") {
        this.$root.address_id = this.$root.address[0].id;
      }
      for (let i = 0; i < this.$root.address.length; i++) {
        //
        if (this.$root.address[i].id === this.$root.address_id) {
          this.$root.error_message = "";
          this.$root.success_message = "";
          axios
            .get(this.$root.api_url + `/pim/pimresponse.php`, {
              params: {
                service: "pincheck",
                store: this.$root.store,
                pincode: this.$root.address[i].pin_code,
              },
            })
            .then((response) => {
              // console.log(response.data.response.success);
              if (response.data.response.success == "1") {
                this.back_page_type = this.$route.query.page_type;
                this.page_type = "delivery";
                this.$router.push({ query: { page_type: "delivery" } });
              }
              if (response.data.result.type === "N") {
                var found = false;
                for (let i = 0; i < this.$root.cart_product.length; i++) {
                  if (this.$root.cart_product[i].product_type != "gift") {
                    this.$root.page_loader = false;
                    this.$root.error_message =
                      "Sorry, selected address in not serviceable. Please try with a different address.";
                    window.scrollTo(0, 0);
                    this.pin_code_success = "";
                    found = true;
                    break;
                  }
                }
                if (found === false) {
                  this.user.city = response.data.result.city;
                  this.user.state = response.data.result.state;
                  this.pin_code_error = "";
                }
              } else {
                if (response.data.result === "") {
                  this.$root.error_message =
                    "Sorry, selected address in not serviceable. Please try with a different address.";
                  this.$root.page_loader = false;
                  window.scrollTo(0, 0);
                } else {
                  if (response.data.result.cod === "N") {
                    //this.payment_method = 'payu';
                    this.cod_hide = false;
                    this.$root.page_loader = false;
                    this.cod_msg =
                      "Due to regulatory & operational restrictions, we are unable to offer Cash on delivery in the selected Pin code. <span class='green'>Free delivery on PREPAID orders.</span>";
                  } else {
                    this.cod_hide = true;
                    this.cod_msg = "";
                  }
                  this.$cookies.set(
                    window.location.hostname.substring(10, 4) + "_pin",
                    this.$root.address[i].pin_code
                  );
                  this.user.pin_code = this.$root.address[i].pin_code;
                  //this.user_pin_code();
                  this.$root.error_message = "";
                  this.$root.success_message = "";
                  var form = new FormData();
                  form.append("pcart", this.$root.pcart);
                  form.append("cart_session", this.$root.cart_session);
                  form.append("customer_id", this.$root.customer_id);
                  form.append("customer_session", this.$root.customer_session);
                  form.append("address_id", this.$root.address_id);
                  let config = {
                    headers: { "Content-Type": "multipart/form-data" },
                  };
                  axios
                    .post(
                      this.$root.cart_api + "/customer/assign-address",
                      form,
                      config
                    )
                    .then((response) => {
                      if (response.data.success === true) {
                        this.$router.push({ query: { page_type: "delivery" } });
                        this.page_type = "delivery";

                        this.back_page_type = "address";
                        this.$root.success_message = response.data.message;
                        this.$root.error_message = "";
                        this.$root.shipping_charge =
                          response.data.shippingCharge;
                        this.$root.cart_total = response.data.grandTotal;
                        this.$root.cart_subtotal = response.data.subTotal;
                        this.$root.cart_netAmount = response.data.netAmount;
                        this.$root.discount_amount =
                          response.data.discountAmount;

                        if (response.data.data.length > 0) {
                          let ProductsArray = [];
                          // Sorting Products array according to SKU

                          response.data.data.forEach((cart) => {
                            this.last_address = maddress;
                            ProductsArray = [
                              ...ProductsArray,
                              ...cart.products,
                            ];
                            if (cart.cod_block == "0") {
                              this.cus_cod_hide = true;
                            } else {
                              this.cus_cod_hide = false;
                            }
                            if (cart.product_type == "gift") {
                              this.product_type = "gift";
                              this.payment_method = "payu";
                            }

                            this.$cookies.set(
                              window.location.hostname.substring(10, 4) +
                                "_co_add",
                              cart.maddress,
                              "1y"
                            );

                            if (cart.cookieDelete === 1) {
                              this.$cookies.set(
                                window.location.hostname.substring(10, 4) +
                                  "_cart",
                                ""
                              );
                              this.$root.pcart = "";
                            }
                          });

                          this.$root.cart_product = ProductsArray;
                        } else {
                          this.$root.cart_product = [];
                          this.$root.shipping_charge =
                            response.data.shippingCharge;
                          this.$root.cart_total = response.data.grandTotal;
                          this.$root.cart_subtotal = response.data.subTotal;
                          this.$root.cart_netAmount = response.data.netAmount;
                          this.$root.discount_amount =
                            response.data.discountAmount;
                        }
                        this.$root.page_loader = false;
                        // this.$gtm.trackEvent({
                        //     event: 'checkout',
                        //     category: 'Ecommerce',
                        //     action: 'Checkout',
                        //     label: '4',
                        //     ecommerce: {
                        //         checkout: {
                        //             'actionField': { 'step': 4, 'option': 'Address selected' },
                        //             product: this.$root.gtm_product,
                        //         }
                        //     }
                        // });
                      } else {
                        this.$root.error_message = response.data.message;
                        this.$root.success_message = "";
                        this.$root.page_loader = false;
                        window.scrollTo(0, 0);
                        if (response.data.customer_session_status == false) {
                          this.$cookies.set(
                            window.location.hostname.substring(10, 4) +
                              "_customer",
                            "",
                            "1y"
                          );
                          this.$cookies.set(
                            window.location.hostname.substring(10, 4) + "_cs",
                            "",
                            "1y"
                          );
                          this.$root.customer_id = "";
                          this.$root.customer_session = "";
                          this.$cookies.set(
                            window.location.hostname.substring(10, 4) + "_cart",
                            "",
                            "1y"
                          );
                          this.$cookies.set(
                            window.location.hostname.substring(10, 4) +
                              "_carts",
                            "",
                            "1y"
                          );
                          // this.$root.pcart = '';
                          this.$root.cart_session = "";
                          this.$root.cart_product = [];
                          this.$router.push("/login.html");
                        }
                        if (response.data.cart_session_status == false) {
                          this.$cookies.set(
                            window.location.hostname.substring(10, 4) +
                              "_customer",
                            "",
                            "1y"
                          );
                          this.$cookies.set(
                            window.location.hostname.substring(10, 4) + "_cs",
                            "",
                            "1y"
                          );
                          this.$root.customer_id = "";
                          this.$root.customer_session = "";
                          this.$cookies.set(
                            window.location.hostname.substring(10, 4) + "_cart",
                            "",
                            "1y"
                          );
                          this.$cookies.set(
                            window.location.hostname.substring(10, 4) +
                              "_carts",
                            "",
                            "1y"
                          );
                          // this.$root.pcart = '';
                          this.$root.cart_session = "";
                          this.$root.cart_product = [];
                          this.$router.push("/cart.html");
                        }
                      }
                    })
                    .catch((error) => {
                      this.$root.page_loader = false;
                      if (error.message === "Network Error") {
                        this.$root.error_message =
                          "Oops there seems to be some Network issue, please try again.";
                      }
                      window.scrollTo(0, 0);
                    });
                }
              }
            })
            .catch((error) => {
              if (error.message === "Network Error") {
                this.$root.error_message =
                  "Oops there seems to be some Network issue, please try again.";
              }
              window.scrollTo(0, 0);
            });
        }
      } //
    }, //
    user_pin_code: function () {
      var pin_code = /^([0-9]{6,})+$/;
      if (this.user.pin_code.match(pin_code)) {
        this.$root.error_message = "";
        this.$root.success_message = "";
        axios
          .get(this.$root.api_url + `/pim/pimresponse.php`, {
            params: {
              service: "pincheck",
              store: this.$root.store,
              pincode: this.user.pin_code,
            },
          })
          .then((response) => {
            if (response.data.result === "") {
              this.pin_code_error = "Sorry this pincode is not serviceable.";
              this.$root.page_loader = false;
              window.scrollTo(0, 0);
            } else {
              if (response.data.result.type == "N") {
                var found = false;
                for (let i = 0; i < this.$root.cart_product.length; i++) {
                  if (this.$root.cart_product[i].product_type != "gift") {
                    this.pin_code_error =
                      "Sorry this pincode is not serviceable.";
                    window.scrollTo(0, 0);
                    this.pin_code_success = "";
                    found = true;
                    break;
                  }
                }
                if (found === false) {
                  this.user.city = response.data.result.city;
                  this.user.state = response.data.result.state;
                  this.pin_code_error = "";
                }
              } else {
                if (response.data.result.cod === "N") {
                  //this.payment_method = 'payu';
                  this.cod_hide = false;
                  this.cod_msg =
                    "Due to regulatory & operational restrictions, we are unable to offer Cash on delivery in the selected Pin code. <span class='green'>Free delivery on PREPAID orders.</span>";
                  //var form = new FormData();
                  //form.append("pcart", this.$root.pcart);
                  //form.append("payment_method", "payu");
                  //let config = { headers: { 'Content-Type': 'multipart/form-data' } }
                  //axios.post(this.$root.cart_api + '/cart/switch-payment-method', form, config)
                  //.then(response => {
                  //if (response.data.success === true) {
                  //this.$root.cart_subtotal = response.data.data.order_subtotal;
                  //this.$root.cart_total = response.data.data.grand_total;
                  //this.cod_charges = response.data.data.cod_charge;
                  //}
                  //})
                } else {
                  this.cod_hide = true;
                  this.cod_msg = "";
                  //var form = new FormData();
                  //form.append("pcart", this.$root.pcart);
                  //form.append("payment_method", "cod");
                  //let config = { headers: { 'Content-Type': 'multipart/form-data' } }
                  //axios.post(this.$root.cart_api + '/cart/switch-payment-method', form, config)
                  //.then(response => {
                  //if (response.data.success === true) {
                  //this.$root.cart_subtotal = response.data.data.order_subtotal;
                  //this.$root.cart_total = response.data.data.grand_total;
                  //this.cod_charges = response.data.data.cod_charge;
                  //}
                  //})
                }
                $cookies.set(
                  window.location.hostname.substring(10, 4) + "_pin",
                  this.user.pin_code
                );
                this.user.city = response.data.result.city;
                this.user.state = response.data.result.state;
                this.pin_code_success =
                  response.data.response.success_message_sort;
                this.pin_code_error = "";
                this.state_error = "";
                if (response.data.result.city != "") {
                  this.city_error = "";
                }
              }
            }
          })
          .catch((error) => {
            if (error.message === "Network Error") {
              this.$root.error_message =
                "Oops there seems to be some Network issue, please try again.";
            }
            this.pin_code_success = "";
            window.scrollTo(0, 0);
          });
      } else {
        this.pin_code_error = "Please enter valid Pin code";
        this.pin_code_success = "";
      }
    },
    user_phone: function () {
      var phoneno = /^([0-9]{10,})+$/;
      if (this.user.phone.match(phoneno)) {
        this.phone_error = "";
      } else {
        this.phone_error = "Please enter valid Phone Number";
      }
    },
    pushnotification(customerId){

			let pushtoken=  $cookies.get(
              window.location.hostname.substring(10, 4) + "_devicetoken"
            );
            let platform=$cookies.get(
              window.location.hostname.substring(10, 4) + "_platform"
            );
				
				var form = new FormData();
				form.append("fcm_device_token", pushtoken);
        form.append("customer_id", customerId);
				form.append("platform", platform);
				axios.post(`${this.$root.admin_api}/push-notification`,form)
				.then((res) => {
					console.log(res)
				})
				.catch((err) => {
					console.log(err)		
				});


    },
    mobile_no: function () {
      this.resend_otp_time = 60;
      var phoneno = /^([0-9]{10,})+$/;
      if (this.mobile_number.match(phoneno)) {
        this.mobile_error = "";
        if (this.mobile_number.length == "10") {
          this.$root.error_message = "";
          this.$root.success_message = "";
          this.mobile = true;
          setTimeout(() => {
            this.$refs.otpCheckout.focus();
          }, 0);
          this.$root.error_message = "";
          this.$root.success_message = "";
          var form = new FormData();
          form.append("phone", this.mobile_number);
          let config = { headers: { "Content-Type": "multipart/form-data" } };
          axios
            .post(this.$root.cart_api + "/customer/send-otp", form, config)
            .then((response) => {
              if (response.data.success === true) {
                this.isOtp = true;
                this.$root.success_message = response.data.message;
                this.$root.error_message = "";
                // this.$gtm.trackEvent({
                //     event: 'Login',
                //     category: 'Login',
                //     action: 'OTP Sent'
                // });
              } else {
                this.$root.error_message = response.data.message;
                this.$root.success_message = "";
              }
            })
            .catch((error) => {
              this.$root.page_loader = false;
              if (error.message === "Network Error") {
                this.$root.error_message =
                  "Oops there seems to be some Network issue, please try again.";
              }
              window.scrollTo(0, 0);
            });
        } else {
          this.mobile = false;
          this.otp = false;
          this.otp_number = "";
        }
      } else {
        this.mobile = false;
        this.mobile_error = "Please enter valid mobile number";
      }
    },
    g_mobile_no: function () {
      this.resend_otp_time = 60;
      var phoneno = /^([0-9]{10,})+$/;
      if (this.mobile_number.match(phoneno)) {
        this.mobile_error = "";
        if (this.mobile_number.length == "10") {
          this.user.phone = this.mobile_number;
          this.$root.error_message = "";
          this.$root.success_message = "";
          this.mobile = true;
          var form = new FormData();
          form.append("phone", this.mobile_number);
          let config = { headers: { "Content-Type": "multipart/form-data" } };
          axios
            .post(
              this.$root.cart_api + "/customer/validate-customer",
              form,
              config
            )
            .then((response) => {
              if (response.data.success === true) {
                this.old_customer = true;
              }
            });
        } else {
          this.mobile = false;
          this.old_customer = false;
          this.otp = false;
          this.otp_number = "";
        }
      } else {
        this.mobile = false;
        this.c_login = false;
        this.old_customer = false;
        this.mobile_error = "Please enter valid mobile number";
        this.$root.g_customer_id = "";
      }
    },
    groupByKey(array, key) {
      return array.reduce((hash, obj) => {
        if (obj[key] === undefined) return hash;
        return Object.assign(hash, {
          [obj[key]]: (hash[obj[key]] || []).concat(obj),
        });
      }, {});
    },
    getAddress() {
      // console.log(" i am called");
      var form = new FormData();
      form.append("customer_id", this.$root.customer_id);
      form.append("customer_session", this.$root.customer_session);
      form.append("store", this.$root.store);
      axios
        .post(this.$root.cart_api + "/customer/get-last-addresses", form)
        .then((response) => {
          if (response.data.success === true) {
            // console.log(response);
            this.$root.locationAddresses = response.data.data;
          }
        })
        .catch((err) => {});
    },
    setCenter(marker) {
      this.markers[0].position.lat = marker.latLng.lat();
      this.markers[0].position.lng = marker.latLng.lng();
      this.$root.location.lat = marker.latLng.lat();
      this.$root.location.long = marker.latLng.lng();
      this.reverseGeocodeText();
    },
    reverseGeocodeText() {
      const that = this;
      // console.log(this.$root.location.lat);
      axios
        .get(
          `https://maps.google.com/maps/api/geocode/json?latlng=${this.$root.location.lat},${this.$root.location.long}&key=AIzaSyABzA9XnM_g51esLxbDQdAdZAjtz3wjIMc`
        )
        .then((response) => {
          this.user.pin_code =
            response.data.results[0].address_components[
              response.data.results[0].address_components.length - 1
            ].long_name;
          this.user.city =
            response.data.results[0].address_components[3].long_name;
          this.user.address = `${response.data.results[0].address_components[0].long_name}, ${response.data.results[0].address_components[1].long_name}`;
          this.edit.pin_code =
            response.data.results[0].address_components[
              response.data.results[0].address_components.length - 1
            ].long_name;
          this.edit.city =
            response.data.results[0].address_components[3].long_name;
          this.edit.address = `${response.data.results[0].address_components[0].long_name}, ${response.data.results[0].address_components[1].long_name}`;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => (this.loading = false));
    },
    get_cart: function () {

     
      this.$root.pcart = this.$cookies.get(
        window.location.hostname.substring(10, 4) + "_cart",
        ""
      );
      if (
        this.$root.pcart != null &&
        this.$root.pcart != "" &&
        this.$root.pcart != "undefined"
      ) {
        this.$root.page_loader = true;
        var form = new FormData();
        form.append("pcart", this.$root.pcart);
        form.append("cart_session", this.$root.cart_session);
        axios
          .post(this.$root.cart_api + "/cart/get-cart", form)
          .then((response) => {
            if (response.data.success === true) {
              
              // this.$router.push({ query: { page_type: "shipping" } });
              // this.page_type = this.$route.query.page_type;
              this.$root.page_loader = false;

              if (this.$root.pcart === null) {
                //  this.$root.pcart = response.data.data.pcart
                // this.$store.dispatch('getPcart', response.data.data.pcart)
              }

              this.$root.shipping_charge = response.data.shippingCharge;
              this.$root.cart_total = response.data.grandTotal;
              this.$root.cart_subtotal = response.data.subTotal;
              this.$root.cart_netAmount = response.data.netAmount;
              this.$root.discount_amount = response.data.discountAmount;

              if (response.data.data.length > 0) {
                let ProductsArray = [];
                // Sorting Products array according to SKU

                response.data.data.forEach((cart) => {
                 
                  this.otpquotes.push(cart.order_quote_id)
                  ProductsArray = [...ProductsArray, ...cart.products];
                  if (cart.is_grocery) {
                    this.isGrocery = true;
                  }
                  if (cart.cookieDelete === 1) {
                    this.$cookies.set(
                      window.location.hostname.substring(10, 4) + "_cart",
                      ""
                    );
                    this.$root.pcart = "";
                  }
                  if (
                    cart.discount_code != "" &&
                    cart.discount_code != null &&
                    cart.discount_by != "platform"
                  ) {
                    let coupon = {
                      store: cart.store,
                      coupon_code: cart.discount_code,
                    };
                    this.applied_coupon_arr.push(coupon);
                  }
                  if (cart.discount_by == "platform") {
                    let coupon = {
                      store: 0,
                      coupon_code: cart.discount_code,
                    };
                    if (this.applied_coupon_arr.length == 0) {
                      this.applied_coupon_arr.push(coupon);
                    }
                  }
                });

                this.$root.cart_product = ProductsArray;
                this.getCartChecoutLoader = false

                this.getCouponList();
                // this.cartProductLoader
              } else {
                this.$root.cart_product = [];
                this.$root.shipping_charge = response.data.shippingCharge;
                this.$root.cart_total = response.data.grandTotal;
                this.$root.cart_subtotal = response.data.subTotal;
                this.$root.cart_netAmount = response.data.netAmount;
                this.$root.discount_amount = response.data.discountAmount;
              }

              if (this.$root.cart_product.length === 0) {
                this.$router.push("/cart.html");
              }
              if (
                (this.$root.customer_id == "" ||
                  this.$root.customer_id == null) &&
                response.data.data.maddress != "" &&
                this.$route.query.step == "payment"
              ) {
                this.mobile_number = response.data.data.maddress.phone;
                this.user.name = response.data.data.maddress.full_name;
                this.user.address = response.data.data.maddress.street_address;
                this.page_type = "payment";
                this.$router.push({ query: { page_type: "payment" } });
                this.user_pin_code();
                this.back_page_type = "login";
                if (this.last_address != "" && this.last_address != null) {
                  this.page_type = "payment";
                  this.$router.push({ query: { step: "payment" } });
                  this.back_page_type = "login";
                }
              }
              if (
                this.$root.customer_id != "" &&
                this.$root.customer_id != null &&
                response.data.data.maddress != "" &&
                this.$route.query.step == "payment"
              ) {
                if (response.data.data.customer.cod_block) {
                  if (response.data.data.customer.cod_block == "0") {
                    this.cus_cod_hide = true;
                  } else {
                    this.cus_cod_hide = false;
                  }
                }
                this.mobile_number = response.data.data.maddress.phone;
                this.user.name = response.data.data.maddress.full_name;
                this.user.address = response.data.data.maddress.street_address;
                this.back_page_type = "address";
                this.page_type = "payment";
                this.user_pin_code();
                if (this.last_address != "" && this.last_address != null) {
                  this.page_type = "payment";
                  this.$router.push({ query: { step: "payment" } });
                  this.back_page_type = "address";
                }
              }
              if (
                this.$root.customer_id != "" &&
                this.$root.customer_id != null &&
                response.data.data.maddress != "" &&
                this.$route.query.step != "payment"
              ) {
                if (response.data.data.customer.cod_block) {
                  if (response.data.data.customer.cod_block == "0") {
                    this.cus_cod_hide = true;
                  } else {
                    this.cus_cod_hide = false;
                  }
                }
                this.page_type = "delivery";
                this.$router.push({ query: {} });
                if (this.last_address != "" && this.last_address != null) {
                  this.back_page_type = "address";
                  this.page_type = "payment";
                  this.$router.push({ query: { step: "payment" } });
                }
              }
              // console.log("callrfdsfsefs");
              if (
                this.$root.customer_id != "" &&
                this.$root.customer_id != null &&
                this.$root.address.length === 0 &&
                response.data.data.maddress != "" &&
                this.$route.query.step != "payment"
              ) {
                this.page_type = "delivery";
                this.$router.push({ query: {} });
                if (this.last_address != "" && this.last_address != null) {
                  this.back_page_type = "new_address_page";
                  this.page_type = "payment";
                  this.$router.push({ query: { step: "payment" } });
                }
              }
              if (
                (this.$root.customer_id == "" ||
                  this.$root.customer_id == null) &&
                response.data.data.maddress != "" &&
                this.$route.query.step != "payment"
              ) {
                this.mobile_number = response.data.data.maddress.phone;
                this.user.name = response.data.data.maddress.full_name;
                this.user.address = response.data.data.maddress.street_address;
                this.user.address_type =
                  response.data.data.maddress.address_type;
                this.user.email = response.data.data.customer.email;
                this.page_type = "login";
                this.$router.push({ query: {} });
                if (this.last_address != "" && this.last_address != null) {
                  this.back_page_type = "login";
                  this.page_type = "payment";
                  this.$router.push({ query: { step: "payment" } });
                }
              }
              if (
                (this.$root.customer_id == "" ||
                  this.$root.customer_id == null) &&
                response.data.data.maddress == "" &&
                this.$route.query.step == "payment"
              ) {
                this.page_type = "login";
                this.$router.push({ query: {} });
                if (this.last_address != "" && this.last_address != null) {
                  this.back_page_type = "login";
                  this.page_type = "payment";
                  this.$router.push({ query: { step: "payment" } });
                }
              }
              if (
                (this.$root.customer_id == null ||
                  this.$root.customer_id == "") &&
                this.$route.query.step != payment &&
                response.data.data.maddress == ""
              ) {
                this.page_type = "login";
                this.$router.push({ query: {} });
                if (this.last_address != "" && this.last_address != null) {
                  this.back_page_type = "login";
                  this.page_type = "payment";
                  this.$router.push({ query: { step: "payment" } });
                }
              }
              this.getCouponList();
            } else {
              this.$root.page_loader = false;
              this.$root.error_message = response.data.message;
              if (response.data.cart_session_status == false) {
                this.$cookies.set(
                  window.location.hostname.substring(10, 4) + "_customer",
                  "",
                  "1y"
                );
                this.$cookies.set(
                  window.location.hostname.substring(10, 4) + "_cs",
                  "",
                  "1y"
                );
                this.$root.customer_id = "";
                this.$root.customer_session = "";
                this.$cookies.set(
                  window.location.hostname.substring(10, 4) + "_cart",
                  "",
                  "1y"
                );
                this.$cookies.set(
                  window.location.hostname.substring(10, 4) + "_carts",
                  "",
                  "1y"
                );
                // this.$root.pcart = '';
                this.$root.cart_session = "";
                this.$root.cart_product = [];
                this.$router.push("/cart.html");
              }
            }
          })
          .catch((error) => {
            this.$root.page_loader = false;
            if (error.message === "Network Error") {
              this.$root.error_message =
                "Oops there seems to be some Network issue, please try again.";
            }
            window.scrollTo(0, 0);
          });
      }
    },
  },
  watch: {
    // "$root.back_after_login":function(){
    //     if(this.$root.back_after_login==false){
    //         if (!this.$root.address.length) {
    //             this.page_type = 'new_address_page';
    //         }
    //         else
    //         {
    //             this.page_type = 'address';
    //         }
    //     }
    // },
    $route(to, from) {
      if (this.$route.query) {
        if (this.$route.query.page_type) {
          if (this.$route.query.page_type == "delivery") {
            this.removePrescription();
            this.removeotprequired();
            this.getPaymentMethods();
          }
        }
      }
    },
    otp_number: {
      handler: function (after, before) {
        var otpno = /^\d*(?:\.\d{1,2})?$/;
        if (this.otp_number.match(otpno)) {
          this.otp_error = "";
          if (this.otp_number.length == "4") {
            this.$root.page_loader = true;
            this.otp = true;
            this.$root.error_message = "";
            this.$root.success_message = "";
            this.$root.customer_id = "";
            var form = new FormData();
            form.append("phone", this.mobile_number);
            form.append("pcart", this.$root.pcart);
            form.append("cart_session", this.$root.cart_session);
            form.append("otp", this.otp_number);
            let config = { headers: { "Content-Type": "multipart/form-data" } };
            axios
              .post(
                this.$root.cart_api + "/customer/validate-otp",
                form,
                config
              )
              .then((response) => {
                if (response.data.success === true) {
                  this.otp_number = "";
                  this.isOtp = false;
                  this.$root.page_loader = false;
                  this.$root.error_message = "";
                  this.$root.success_message = response.data.message;
                  this.$toast.success(response.data.message, {
                    position: "top",
                    duration: 4000,
                  });

                  this.$cookies.set(
                    window.location.hostname.substring(10, 4) + "_customer",
                    response.data.data.customer.id,
                    "1y"
                  );
                  this.$root.wishListProducts =
                    response.data.data[0].wishlist_count;
                  this.$cookies.set(
                    window.location.hostname.substring(10, 4) + "_cs",
                    response.data.data[0].customer_session,
                    "1y"
                  );
                  this.$root.customer_id = response.data.data.customer.id * 1;
                  this.$root.customer_session =
                    response.data.data[0].customer_session;
                  this.$root.address = [...response.data.data.address];

                  // this.$root.cart_product = response.data.data.products;
                  this.$root.customer_detail = response.data.data.customer;

                  this.getAddress();
                  if (response.data.data.pcart) {
                    this.$root.pcart = response.data.data.pcart;
                    this.$root.thankyou_cart = response.data.data.pcart;
                    this.$cookies.set(
                      window.location.hostname.substring(10, 4) + "_cart",
                      response.data.data.pcart,
                      "1y"
                    );
                    this.$cookies.set(
                      window.location.hostname.substring(10, 4) + "_carts",
                      response.data.data.cart_session,
                      "1y"
                    );

                    this.$root.cart_session = response.data.data.cart_session;
                  }
                  if (this.$root.address.length != 0) {
                    this.$cookies.set(
                      window.location.hostname.substring(10, 4) + "_pin",
                      this.$root.address[0].pin_code
                    );
                    for (let i = 0; i < this.$root.address.length; i++) {
                      if (i == 0) {
                        this.$root.address_id = this.$root.address[i].id * 1;
                        this.$root.select_address_no = i;
                        this.user.phone = this.$root.address[0].phone;
                      }
                    }
                  }
                  if (
                    this.$root.address.length === 0 &&
                    this.$root.customer_id != null
                  ) {
                    this.page_type = "new_address_page";
                    // this.$gtm.trackEvent({
                    //     event: 'checkout',
                    //     category: 'Ecommerce',
                    //     action: 'Checkout',
                    //     label: '3',
                    //     ecommerce: {
                    //         checkout: {
                    //             'actionField': { 'step': 3, 'option': 'shipping address' },
                    //             product: this.$root.gtm_product,
                    //         }
                    //     }
                    // });
                  }
                  if (
                    this.$root.address.length != 0 &&
                    this.$root.customer_id != null
                  ) {
                    this.page_type = "shipping";
                    // this.$gtm.trackEvent({
                    //     event: 'checkout',
                    //     category: 'Ecommerce',
                    //     action: 'Checkout',
                    //     label: '3',
                    //     ecommerce: {
                    //         checkout: {
                    //             'actionField': { 'step': 3, 'option': 'shipping address' },
                    //             product: this.$root.gtm_product,
                    //         }
                    //     }
                    // });
                  }
                  // this.$gtm.trackEvent({
                  //     event: 'Login',
                  //     category: 'Login',
                  //     action: 'Login Success'
                  // });
                  // this.$gtm.trackEvent({
                  //     event: 'Login_status',
                  //     category: 'Login_status',
                  //     action: 'Login Success',
                  //     Mobile_no: this.$root.customer_detail.phone,
                  //     Email: this.$root.customer_detail.email,
                  // });
                  this.pushnotification(response.data.data.customer.id)
                  window.location.reload();
                } else {
                  this.$toast.error(response.data.message, {
                    position: "top",
                    duration: 4000,
                  });
                  this.$root.success_message = "";
                  this.$root.page_loader = false;
                  this.$root.error_message = response.data.message;
                  this.$root.customer_id = "";
                  if (response.data.cart_session_status == false) {
                    this.$cookies.set(
                      window.location.hostname.substring(10, 4) + "_customer",
                      "",
                      "1y"
                    );
                    this.$cookies.set(
                      window.location.hostname.substring(10, 4) + "_cs",
                      "",
                      "1y"
                    );
                    this.$root.customer_id = "";
                    this.$root.customer_session = "";
                    this.$cookies.set(
                      window.location.hostname.substring(10, 4) + "_cart",
                      "",
                      "1y"
                    );
                    this.$cookies.set(
                      window.location.hostname.substring(10, 4) + "_carts",
                      "",
                      "1y"
                    );
                    // this.$root.pcart = '';
                    this.$root.cart_session = "";
                    this.$root.cart_product = [];
                    this.$router.push("/cart.html");
                  }
                  // this.$gtm.trackEvent({
                  //     event: 'Login',
                  //     category: 'Login',
                  //     action: 'Login Failure',
                  //     label: response.data.message
                  // });
                }
              })
              .catch((error) => {
                this.$root.page_loader = false;
                if (error.message === "Network Error") {
                  this.$root.error_message =
                    "Oops there seems to be some Network issue, please try again.";
                }
                window.scrollTo(0, 0);
              });
          } else {
            this.otp = false;
          }
        } else {
          this.otp = false;
          this.otp_error = "Please enter valid OTP";
        }
      },
    },
  },
  mounted() {
    //  Catches event on browser back button

    // window.onpopstate = (event) => {
    // 	let pageType
    // 	if(this.$route.query.page_type)  {
    // 		pageType = this.$route.query.page_type
    // 	}
    // 	if(this.$route.query.step)  {
    // 		pageType = this.$route.query.step
    // 	}
    // 	this.changePageType(pageType)

    // };

    //  ends here

    this.get_cart();
    // this.getTimeSlots();
    this.getCartWiseSlots();
    if (
      this.$cookies.get(window.location.hostname.substring(10, 4) + "_pin") !=
      null
    ) {
      this.user.pin_code = this.$cookies.get(
        window.location.hostname.substring(10, 4) + "_pin"
      );
    }

    if (this.user.pin_code != "" || this.user.pin_code != null) {
      this.user_pin_code();
    }
    this.$root.error_message = "";
    this.$root.success_message = "";
    // if (this.$root.address != '') {
    //     this.user.phone = this.$root.address[0].phone;
    // }
    if (this.$route.query.payu === "failed") {
      this.$root.error_message = "Something Went Wrong, Please Try Again";
    }
  },
  beforeMount() {
    document.addEventListener("keyup", (evt) => {
      if (evt.keyCode == 27) {
        this.coupon_popup = true;
      }
    });
  },
  async created() {
	 
    window.addEventListener("popstate", this.popstateEventAction);
    // this.getPaymentMethods();
    if (!this.$root.address) {
      window.location.reload();
    }
    // this.page_type = this.$route.query.page_type
    let bodyTag = document.getElementsByTagName("body");
    bodyTag[0].classList.add("m_bottom");
    // this.getCouponList();

    await this.get_account();

    if (this.selectedSlot != "") {
      this.page_type = "payment";
    } else {
      this.page_type = "delivery";
    }

    if (
      this.$root.pcart == null ||
      this.$root.pcart == "" ||
      this.$root.pcart == "undefined"
    ) {
      this.$router.push("cart.html");
    }
    this.last_address = this.$cookies.get(
      window.location.hostname.substring(10, 4) + "_co_add"
    );
    // if (
    // 	this.last_address != "" &&
    // 	this.last_address != null &&
    // 	this.last_address != undefined
    // ) {
    // 	this.user.name = this.last_address.full_name;
    // 	this.user.address = this.last_address.street_address;
    // 	this.user.pin_code = this.last_address.pin_code;
    // 	this.user.city = this.last_address.city;
    // 	this.user.state = this.last_address.state;
    // 	this.user.phone = this.last_address.phone;
    // 	this.mobile_number = this.last_address.phone;
    // 	this.user.address_type = this.last_address.address_type;
    // 	//this.g_checkout();
    // 	this.$root.error_message = "";
    // 	this.$root.success_message = "";
    // 	var form = new FormData();
    // 	form.append("pcart", this.$root.pcart);
    // 	form.append("cart_session", this.$root.cart_session);
    // 	form.append("customer_id", this.last_address.customer_id);
    // 	form.append("customer_session", this.$root.customer_session);
    // 	form.append("address_id", "989999");
    // 	form.append("address_id", this.last_address.id);
    // 	let config = { headers: { "Content-Type": "multipart/form-data" } };
    // 	axios
    // 		.post(
    // 			this.$root.cart_api + "/customer/guest-assign-address",
    // 			form,
    // 			config
    // 		)
    // 		.then((response) => {
    // 			if (response.data.success === true) {
    // 				if (response.data.data.customer.cod_block) {
    // 					if (response.data.data.customer.cod_block == "0") {
    // 						this.cus_cod_hide = true;
    // 					} else {
    // 						this.cus_cod_hide = false;
    // 					}
    // 				}
    // 				this.$root.success_message = response.data.message;
    // 				this.$root.error_message = "";
    // 				for (let i = 0; i < response.data.data.products.length; i++) {
    // 					if (response.data.data.products[i].product_type == "gift") {
    // 						this.product_type = "gift";
    // 						this.payment_method = "payu";
    // 					}
    // 				}
    // 				this.$root.page_loader = false;
    // 			} else {
    // 				//this.$root.error_message = response.data.message;
    // 				this.$root.success_message = "";
    // 				this.$root.page_loader = false;
    // 				window.scrollTo(0, 0);
    // 				if (
    // 					response.data.success == false &&
    // 					response.data.message == "Invalid Address"
    // 				) {
    // 					this.last_address = null;
    // 					this.$cookies.set(
    // 						window.location.hostname.substring(10, 4) + "_co_add",
    // 						"",
    // 						"1y"
    // 					);
    // 					//this.page_type = 'login';
    // 					// if (this.$root.address.length === 0 && this.$root.customer_id != null && this.$root.customer_id != '') {
    // 					//     this.page_type = 'shipping';
    // 					//     this.$router.push('/checkout.html')
    // 					// }
    // 					if (
    // 						this.$root.customer_id != null ||
    // 						this.$root.customer_id != ""
    // 					) {
    // 						this.page_type = "login";
    // 						this.$router.push("/checkout.html");
    // 					}
    // 				}
    // 				if (response.data.customer_session_status == false) {
    // 					this.$cookies.set(
    // 						window.location.hostname.substring(10, 4) + "_customer",
    // 						"",
    // 						"1y"
    // 					);
    // 					this.$cookies.set(
    // 						window.location.hostname.substring(10, 4) + "_cs",
    // 						"",
    // 						"1y"
    // 					);
    // 					this.$root.customer_id = "";
    // 					this.$root.customer_session = "";
    // 					this.$cookies.set(
    // 						window.location.hostname.substring(10, 4) + "_cart",
    // 						"",
    // 						"1y"
    // 					);
    // 					this.$cookies.set(
    // 						window.location.hostname.substring(10, 4) + "_carts",
    // 						"",
    // 						"1y"
    // 					);
    // 					// this.$root.pcart = '';
    // 					this.$root.cart_session = "";
    // 					this.$root.cart_product = [];
    // 					this.$router.push("/login.html");
    // 				}
    // 				if (response.data.cart_session_status == false) {
    // 					this.$cookies.set(
    // 						window.location.hostname.substring(10, 4) + "_customer",
    // 						"",
    // 						"1y"
    // 					);
    // 					this.$cookies.set(
    // 						window.location.hostname.substring(10, 4) + "_cs",
    // 						"",
    // 						"1y"
    // 					);
    // 					this.$root.customer_id = "";
    // 					this.$root.customer_session = "";
    // 					this.$cookies.set(
    // 						window.location.hostname.substring(10, 4) + "_cart",
    // 						"",
    // 						"1y"
    // 					);
    // 					this.$cookies.set(
    // 						window.location.hostname.substring(10, 4) + "_carts",
    // 						"",
    // 						"1y"
    // 					);
    // 					// this.$root.pcart = '';
    // 					this.$root.cart_session = "";
    // 					this.$root.cart_product = [];
    // 					this.$router.push("/cart.html");
    // 				}
    // 			}
    // 		});
    // }
    this.payment_method = this.$cookies.get(
      window.location.hostname.substring(10, 4) + "_lastpay"
    );
    this.razorpay_form.name = "Shop For WNDW";
    this.razorpay_form.image = "/img/fav2.ico";
    this.razorpay_form.theme.color = "#ba2126";
    window.scrollTo(0, 0);
    this.$root.minicart = true;

    if (
      this.$root.customer_id == null ||
      this.$root.customer_id == "" ||
      this.$root.customer_id == "undefined"
    ) {
      this.page_type = "login";
      // setTimeout(() => this.$gtm.trackEvent({
      //     event: 'checkout',
      //     category: 'Ecommerce',
      //     action: 'Checkout',
      //     label: '2',
      //     ecommerce: {
      //         checkout: {
      //             'actionField': { 'step': 2, 'option': 'Sign up' },
      //             product: this.$root.gtm_product,
      //             mobile: this.mobile_number,
      //         }
      //     }
      // }), 100);
    }
    if (this.$root.customer_id != null && this.$root.customer_id != "") {
      this.$router.push({ query: { page_type: "shipping" } });
      this.page_type = "shipping";
      
      if(this.$root.address.length==0){
       this.page_type = "new_address_page";
      }
      else{
        this.page_type = "shipping";
      }
      
      // setTimeout(() => this.$gtm.trackEvent({
      //     event: 'checkout',
      //     category: 'Ecommerce',
      //     action: 'Checkout',
      //     label: '3',
      //     ecommerce: {
      //         checkout: {
      //             'actionField': { 'step': 3, 'option': 'shipping address' },
      //             product: this.$root.gtm_product,
      //         }
      //     }
      // }), 100);
    }

    // if(this.last_address!=''&&this.last_address!=null){
    //     this.back_page_type = 'address';
    //     this.page_type = 'payment';
    //     this.$router.push({ query: { step: 'payment' } });
    // }
    console.log("add",this.$root.address)
    console.log(this.page_type)
  },
};
</script>